<template>
    <div >
        <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1">
            <!-- @contextmenu.prevent="handleContextMenu" -->
         
            <app-toolbar :toolbar="toolbar"></app-toolbar>
            <v-tooltip bottom>
                <template v-slot:activator="{on,attrs}">
                    <v-btn dark color="#455A64" class="ml-2" @click="getAllData()" v-on="on" v-bind="attrs">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Refresh</span>
            </v-tooltip>
            <v-tooltip bottom v-if="getTabName == 'HRD VIEW TABLE' || getTabName == 'PLANNER VIEW TABLE'">
                <template v-slot:activator="{on,attrs}">
                    <v-btn color="#455A64" class="ml-2" @click="ExtractData()" v-on="on" v-bind="attrs">
                        <v-icon color="white">mdi-table-arrow-down</v-icon>
                    </v-btn>
                </template>
                <span>Extract Data</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{on,attrs}">
                    <v-btn v-if="loggedInUser.user_id == '39840' || loggedInUser.user_id == 'CRS2025'" dark color="#455A64" class="ml-2" @click="deleteManualDialog = true" v-on="on" v-bind="attrs">
                        <v-icon>mdi-delete-variant</v-icon>
                    </v-btn>
                </template>
                <span>Delete</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{on,attrs}">
                    <v-btn v-if="loggedInUser.user_id == '39840' || loggedInUser.user_id == 'CRS2025'" dark color="#455A64" class="ml-2" @click="deleteToBossDialog = true" v-on="on" v-bind="attrs">
                        <v-icon>mdi-trash-can</v-icon>
                    </v-btn>
                </template>
                <span>Delete To Boss</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{on,attrs}">
                    <v-btn v-if="loggedInUser.user_id == '39840' || loggedInUser.user_id == 'CRS2025'" dark color="#455A64" class="ml-2" @click="addToBossDialog = true" v-on="on" v-bind="attrs">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add To Boss</span>
            </v-tooltip>
            
            <v-container fluid>
                <v-row>
                    <v-col cols="2" v-if="defaultTab != 3 && defaultTab != 4">
                        <!-- <v-text-field 
                            v-model="search"
                            outlined 
                            dense
                            label="Search here"
                            v-if="defaultTab != 2"
                            @input="getAllData(), page = 1"
                            :disabled="defaultTab == 3 || defaultTab == 4"
                            :filled="defaultTab == 3 || defaultTab == 4"></v-text-field>
                        <v-text-field 
                            v-model="searchXml"
                            v-else
                            outlined 
                            dense
                            label="Search here"
                            @input="getAllXmlData(), page = 1"
                            :disabled="defaultTab == 3 || defaultTab == 4"
                            :filled="defaultTab == 3 || defaultTab == 4"></v-text-field> -->
                        
                        <v-text-field 
                            v-model="search"
                            outlined 
                            dense
                            label="Search Customer Code"
                            @input="(defaultTab == 0 || defaultTab == 1) ? (searchAll(), formatInput()) : (getAllData(), formatInput())"
                            :disabled="defaultTab == 3 || defaultTab == 4"
                            :filled="defaultTab == 3 || defaultTab == 4"
                            maxlength="18"
                            counter></v-text-field>
                    </v-col>

                    <!-- <template>
                        <div>
                            <v-alert
                                transition="fade-transition"
                                v-model="reminder"
                                dense
                                outlined
                                color="#35a421"
                                elevation="2"
                                type="error"
                                icon="mdi-alert-circle">
                                I'm a dense alert with the <strong>outlined</strong> prop and a <strong>type</strong> of error
                            </v-alert>
                        </div>
                    </template> -->

                    

                    <v-col cols="2" v-if="defaultTab != 3 && defaultTab != 4">
                        <v-select @change="getAllData" v-model="hrdAcceptSelect" label="Hrd Accept Filter" :items="HrdAcceptSelection" outlined dense :disabled="defaultTab == 2 || defaultTab == 3 || defaultTab == 4" :filled="defaultTab == 2 || defaultTab == 3 || defaultTab == 4"></v-select>
                    </v-col>

                    <v-col cols="2" v-if="defaultTab != 3 && defaultTab != 4">
                        <v-select @change="getAllData" v-model="expressSelect" label="Express Plan Filter" :items="ExpressPlanSelection" outlined dense :disabled="defaultTab == 3 || defaultTab == 4" :filled="defaultTab == 3 || defaultTab == 4"></v-select>
                    </v-col>
                    <v-col cols="2" v-if="defaultTab != 3 && defaultTab != 4">
                        <v-select @change="getAllData" v-model="filterDateSelection" :items="filterDate" outlined dense label="Filter" :disabled="defaultTab == 2 || defaultTab == 3 || defaultTab == 4" :filled="defaultTab == 2 || defaultTab == 3 || defaultTab == 4"></v-select>
                    </v-col>
                    <!-- <v-col>
                        <v-select @change="getView()" v-model="filterCreatedBy" :items="filterCreated" outlined dense label="Created By"></v-select>
                    </v-col> -->


                    <v-col cols="2">
                        <v-menu
                            v-model="dateFromMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="filterDateSelection != 'Filter By Date'"
                                    v-model="dateFrom"
                                    label="Date From : "
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense>
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateFrom"
                                @change="getAllData"
                                @input="dateFromMenu = false">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="2">
                        <v-menu
                            v-model="dateToMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="filterDateSelection != 'Filter By Date'"
                                    outlined
                                    dense
                                    v-model="dateTo"
                                    label="Date To : "
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateTo"
                                @input="dateToMenu = false"
                                @change="getAllData">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-container>

            <div class="text-center" style="font-family:Sans-serif">
                <center>
                    <v-overlay v-model="overlay">
                        <v-progress-circular
                            indeterminate
                            :size="120"
                            :width="3"
                        ></v-progress-circular><br>Loading, please wait...
                    </v-overlay>
                </center>
            </div>

            <v-container fluid>
            <v-tabs @change="filterByTab()" v-model="defaultTab" fixed-tabs centered background-color="transparent" color="black">
                <v-tabs-slider></v-tabs-slider>
                    <v-tab active-class="active-tab" justify="center" @click="logTab('HRD VIEW TABLE')" v-if="loggedInUser.is_admin || loggedInUser.is_hrd_viewer || loggedInUser.is_hrd_requestor || loggedInUser.plan_control">
                        HRD VIEW TABLE
                    </v-tab>
                    <v-tab active-class="active-tab" justify="center" @click="logTab('PLANNER VIEW TABLE')" v-if="loggedInUser.is_gc_user || loggedInUser.is_ichijo_user || loggedInUser.is_rulebook_user || loggedInUser.is_admin || loggedInUser.is_special_account || loggedInUser.japan_admin || loggedInUser.plan_control">
                        PLANNER VIEW TABLE
                    </v-tab>
                    <v-tab active-class="active-tab" justify="center" @click="logTab('XML BUNDLE SCHEDULE TABLE')" v-if="loggedInUser.id == 1 || loggedInUser.id == 2 || loggedInUser.id == 15">
                        XML BUNDLE SCHEDULE TABLE
                    </v-tab>
                    <v-tab active-class="active-tab" justify="center" @click="logTab('CAD依頼受付状況')">
                        CAD依頼受付状況
                    </v-tab>
                    <v-tab active-class="active-tab" justify="center" @click="logTab('NOT YET UPLOADED')" v-if="loggedInUser.id == 1 || loggedInUser.id == 2 || loggedInUser.id == 15">
                        NOT YET UPLOADED
                    </v-tab>

                <v-tab-item class="mt-2" v-if="loggedInUser.is_admin || loggedInUser.is_hrd_viewer || loggedInUser.is_hrd_requestor  || loggedInUser.plan_control">
                    <!-- HRD VIEWER -->
                    <v-simple-table class="mainTable" fixed-header height="55vh">
                        <thead>
                            <tr>
                                <th class="sticky-code" style="min-width: 200px !important;"> Customer Code </th>
                                <th class="sticky-revision"> Revision </th>
                                <th class="sticky-attach" width="20px"> Attachments </th>
                                <!-- <th class="text-center"> CAD Request<br>System </th> -->
                                <!-- <th> Created Date </th> WITHOUT SORTING -->
                                <th class="sticky-created" style="cursor:pointer;" @click="hrdCreatedSortBy()"> Created Date
                                    <!-- <v-icon dark small>mdi-arrow-up-down-bold</v-icon> -->
                                    <!-- ! UNCOMMENT BELOW TO USE NEW SORTING THEN COMMENT THE TOP-->
                                    <v-icon dark small v-if="!createdSort">mdi-arrow-up-down-bold</v-icon>
                                    <v-icon dark small v-if="createdSort == 'DESC'">mdi-arrow-down-thin</v-icon>
                                    <v-icon dark small v-if="createdSort == 'ASC'">mdi-arrow-up-thin</v-icon>
                                </th>
                                <th class="th-sticky"> Created By </th>
                                <th class="th-sticky"> Created By Code</th>
                                <th class="th-sticky"> Gravity </th>
                                <th class="th-sticky"> Request Type </th>
                                <th class="th-sticky"> Express </th>
                                <th class="th-sticky"> Hrd Accept </th>
                                <!-- <th> Hrd Accepted Date</th> WITHOUT SORTING -->
                                <th style="cursor:pointer;" @click="hrdAcceptedDateSortBy()"> Hrd Accepted Date
                                    <!-- <v-icon dark small>mdi-arrow-up-down-bold</v-icon> -->
                                    <!-- ! UNCOMMENT BELOW TO USE NEW SORTING THEN COMMENT THE TOP-->
                                    <v-icon dark small v-if="!hrdAcceptSort">mdi-arrow-up-down-bold</v-icon>
                                    <v-icon dark small v-if="hrdAcceptSort == 'DESC'">mdi-arrow-down-thin</v-icon>
                                    <v-icon dark small v-if="hrdAcceptSort == 'ASC'">mdi-arrow-up-thin</v-icon>
                                </th>
                                <th class="th-sticky"> House Type </th>
                                <th class="th-sticky"> House Type Name </th>
                                <th class="th-sticky"> Remarks </th>
                                <th class="th-sticky"> Fire Protection </th>
                                <th class="th-sticky"> Water Tight </th>
                                <th class="th-sticky"> Heavy Snow </th>
                                <th class="th-sticky"> Seismic Isolation </th>
                                <th class="th-sticky"> Rectangle Meter </th>
                                <th class="th-sticky"> Double Earthquake Resistance </th>
                                <th class="th-sticky"> High Fireproof OuterWall </th>
                                <th class="th-sticky"> After Kakou Reason </th>
                                <th class="th-sticky"> Design Contract </th>
                                <th class="th-sticky"> Calculation Basis </th>
                                <th class="th-sticky"> Color Layout </th>
                                <th class="th-sticky" v-show="viewMode"> Dxf </th>
                                <th class="th-sticky" v-show="viewMode"> ColorPers </th>
                                <th class="th-sticky" v-show="viewMode"> HP </th>
                                <th class="th-sticky" v-show="viewMode"> Specification Review </th>
                                <th class="th-sticky" v-show="viewMode"> Web Docs Materials </th>
                                <th class="th-sticky" v-show="viewMode"> Color Layout Points </th>
                                <th class="th-sticky" v-show="viewMode"> ALVS </th>
                                <th class="th-sticky" v-show="viewMode"> Proposal Electrical </th>
                                <!-- <th v-show="viewMode"> Denki Request </th> -->
                                <!-- <th v-show="viewMode"> Electrical </th> -->
                                <th class="th-sticky" v-show="viewMode"> Stop </th>
                                <th class="th-sticky" v-show="viewMode"> Start Drawing </th>
                                <!-- <th v-show="viewMode"> Final Checking </th> -->
                                <th class="th-sticky" v-show="viewMode"> Electrical Drawing </th>
                                <th class="th-sticky" v-show="viewMode"> Arrangement </th>
                                <th class="th-sticky" v-show="viewMode"> Trial Code </th>
                                <th class="th-sticky" v-show="viewMode"> Updated Date </th>
                                <th class="th-sticky" v-show="viewMode"> Updated By Code </th>
                                <th class="th-sticky" v-show="viewMode"> Deleted Date </th>
                                <!-- <th v-show="viewMode"> Deleted By Code </th> -->
                            </tr>
                        </thead>
                        <tbody v-if="nextViewPage.length > 0">
                            <tr  v-for="(item, i) in nextViewPage" :key="i">
                                <!-- :style="[item.hrd_accept == 1 ? {backgroundColor : 'blue'}: '']" -->
                                <td class="sticky-view-code" v-if="loggedInUser.is_hrd_viewer != 1"> <v-btn text dense @click="goToMain(item.customer_code)">{{ item.customer_code }} </v-btn> <v-icon @click="copyControlNumber(item.customer_code)">mdi-content-copy</v-icon></td>
                                <td class="sticky-view-code" v-else>{{ item.customer_code }} &nbsp;<v-icon @click="copyControlNumber(item.customer_code)">mdi-content-copy</v-icon></td>

                                <td class="sticky-view-revision"> {{ item.revision_number }}</td>
                                <td class="sticky-view-attach text-center">
                                    <span class="custom-svg svg-icon_folder pointer" v-if="item.attachments.length > 0" @click="openFileAttDialog(item)">
                                    <!-- <p class="grey--text text--darken-4" > {{ item.request_attach_from }} </p></div> -->
                                    <v-icon color="primary"> mdi-file-table </v-icon></span>
                                </td>
                                <!-- <td v-if="item.from_version"> Version {{ item.from_version}} </td> -->
                                <!-- <td v-else></td> -->
                                <td class="sticky-view-created"> {{ item.created_at}} </td>
                                <td> {{ item.created_by_code }} </td>
                                <td> {{ item.user_id }} </td>


                                <!-- GRAVITY -->
                                <td> 
                                    <!-- {{ item.gravity }}  -->
                                    <span v-if="item.gravity == 0">CADの変更なし (NC)</span>
                                    <span v-if="item.gravity == 1">軽微な変更 (S)</span>
                                    <span v-if="item.gravity == 2">通常の変更 (M)</span>
                                    <span v-if="item.gravity == 3">大きな変更 (L)</span>
                                    <span v-if="item.gravity == 4" class="red--text">Apply in Next CAD Request</span><br>

                                    <span v-if="item.revision_type == 8" style="font-size:8.5px;color:red;margin:0 auto;">HRDミスの修正 (HRD Process)</span>
                                    <span v-else-if="item.revision_type == 9" style="font-size:8.5px;color:red;margin:0 auto;">HRDよりCAD依頼 (CPN)</span>
                                </td>
                                <!-- end of GRAVITY COLUMN -->

                                <!-- REQUEST TYPE -->
                                <td>{{ item.request_type }}</td>
                                <!-- END OF REQUEST TYPE -->

                                <!-- EXPRESS PLAN -->
                                <td> 
                                    <v-chip
                                        class="ma-2"
                                        :color="item.express == '1' ? 'green' : 'red'"
                                        text-color="white"
                                        x-small
                                    >
                                    {{ item.express == '1' ? 'YES' : 'NO' }}
                                    </v-chip>
                                </td>
                                <!-- END OF EXPRESS PLAN -->

                                <!-- HRD ACCEPT -->
                                <td> 
                                    <v-chip
                                        align="center"
                                        class="ma-2"
                                        :color="item.hrd_accept == '1' ? 'blue' : 'red'"
                                        text-color="white"
                                        x-small
                                    >
                                    {{ item.hrd_accept == '1' ? 'YES' : 'NO' }}
                                    </v-chip><br>
                                    <span style="font-size:9.5px;" v-if="item.hrd_accept == 1"><center>{{ item.hrd_accepted_user_id != null ? item.hrd_accepted_user_id : '' }}</center></span>
                                </td>
                                <!-- END -->

                                <!-- HRD ACCEPTED DATE -->
                                <td>
                                    {{ item.hrd_accepted_at }}
                                </td>
                                <!-- END -->

                                <td> {{item.alias}} </td>
                                <!-- <td> {{ item.construction_type_name }} </td> -->
                                <td> {{ item.name }} </td>

                                <!-- REMARKS -->
                                <td> 
                                    <div v-for="(item, index) in item.remarks" :key="index">
                                        <span>
                                            {{item.remark}}
                                        </span>
                                    </div>
                                </td>
                                <!-- END OF REMARKS -->

                                <!-- FIRE PROTECTION -->
                                <td>
                                    <span v-if="item.fire_protection == '1'">なし</span>
                                    <span v-if="item.fire_protection == '2'">準防火仕様</span>
                                    <span v-if="item.fire_protection == '3'">準耐火仕様</span>
                                </td>
                                <!-- END OF FIRE PROTECTION -->

                                <!-- WATER TIGHT -->
                                <td> 
                                    <span v-if="item.water_tight != 0">
                                        {{ item.water_tight }} 
                                    </span>
                                </td>
                                <!-- END OF WATER TIGHT -->

                                <!-- HEAVY SNOW -->
                                <td>
                                    <span v-if="item.heavy_snow == '1'">豪雪仕様</span>
                                </td>
                                <!-- END OF HEAVY SNOW -->

                                <!-- SEISMIC ISOLATION -->
                                <td>  </td> 
                                <!-- END OF SEISMIC ISOLATION -->

                                <td> {{ item.rectangle_meter }} </td>

                                <!-- DOUBLE EARTHQUAKE RESISTANCE -->
                                <td> 
                                    <span v-if="item.double_earthquake_resistance != '1'">なし</span>
                                    <span v-else>あり</span>
                                </td>
                                <!-- END OF DOUBLE EARTHQUAKE RESISTANCE -->

                                <!-- HIGH FIREPROOF OUTER WALL -->
                                <td>
                                    <span v-if="item.high_fireproof_outer_wall != '1'">なし</span>
                                    <span v-else>あり</span>
                                </td>
                                <!-- END OF HIGH FIREPROOF OUTER WALL -->

                                <td> {{ item.kakouirai_reason }} </td>
                                <td> {{ item.design_contract }} </td>
                                <td> {{ item.calculation_basis }} </td>
                                <!-- SITE LAYOUT -->
                                <td> 
                                    <span v-if="item.site_layout == '新規データN' && item.site_layout_option == 'option1'">
                                        <div style="font-size:10.5px;">{{ item.site_layout }}</div>
                                        <div style="font-size:8.5px;color:blue;margin:0 auto;">BOSS送信済み</div>
                                        <div style="font-size:8.5px;">
                                            屋外配管経路図 
                                            <span v-if="item.site_diagram == 'なし'" style="color:red;">{{ item.site_diagram }}</span>
                                            <span v-else style="color:blue;">{{ item.site_diagram }}</span>
                                        </div>
                                    </span>
                                    <span v-else-if="item.site_layout == '新規データN' && item.site_diagram != null">
                                        <div style="font-size:10.5px;margin:0 auto">{{ item.site_layout }}</div>
                                        <div style="color:red;font-size:8.5px;">屋外配管経路図 {{item.site_diagram}}</div>
                                    </span>
                                    <span v-else-if="item.site_layout == '新規データN'">
                                        <div style="height:18px; !important;font-size:10.5px;">{{ item.site_layout }}</div>
                                    </span>
                                    <span v-else-if="item.site_layout == '前回ベースP' && item.new_site_diagram != null">
                                        <div style="font-size:10.5px;margin:0 auto">{{ item.site_layout }}</div>
                                        <div style="color:red;font-size:8.5px;">屋外配管経路図 {{item.new_site_diagram}}</div>
                                    </span>
                                    <span v-else-if="item.site_layout != '新規データN' || item.site_layout != '前回ベースP'">
                                        <div style="font-size:10.5px;height:16px; !important;">{{ item.site_layout }}</div>
                                    </span>
                                    <span v-else>
                                        <div></div>
                                    </span>
                                </td>
                                <!-- END OF SITE LAYOUT -->
                                <td v-show="viewMode"> {{ item.dxf_data_request }} </td>
                                <td v-show="viewMode"> {{ item.color_pers }} </td>
                                <td v-show="viewMode"> {{ item.house_presentation }} </td>
                                <td v-show="viewMode"> {{ item.shio_request }} </td>

                                <!-- WEB DOCUMENT -->
                                <td v-show="viewMode">
                                    <!-- {{ item.web_documents }}  -->
                                    <span v-if="item.web_documents.length > 0" v-for="(ii, i) in item.web_documents" :key="i">
                                        <!-- <span v-if="ii.value == 1">①</span>
                                        <span v-if="ii.value == 2">②</span>
                                        <span v-if="ii.value == 3">③</span>
                                        <span v-if="ii.value == 4">④</span>
                                        <span v-if="ii.value == 5">⑤</span>
                                        <span v-if="ii.value == 6">⑥</span>
                                        <span v-if="ii.value == 7">⑦</span> -->
                                        <v-icon color="red" small>
                                            {{`mdi-numeric-${ii.value}-circle-outline`}}
                                        </v-icon>
                                    </span>
                                </td>
                                <!-- END OF WEB DOCUMENT -->
                                
                                <td v-show="viewMode">{{ item.jiban_plan }}</td>
                                <td v-show="viewMode"> {{ item.alvs }} </td>
                                <td v-show="viewMode">{{ item.pdr }}</td>
                                <!-- <td v-show="viewMode">test</td> -->
                                <td v-show="viewMode"> {{ item.stop }} </td>
                                <td v-show="viewMode">{{ item.final_plan }}</td>
                                <!-- <td v-show="viewMode">test</td> -->
                                
                                <!-- ELECTRICAL DRAWING -->
                                <td v-show="viewMode">
                                    <!-- <span v-if="item.electrical_drawing">
                                        {{ item.electrical_drawing }}
                                    </span> -->
                                    <div v-if="item.electrical_drawing">
                                        <span v-if=" item.electrical_drawing.OPTION_2 == 'あり'">
                                                <span>E更新</span>
                                                <span>あり</span>
                                        </span>
                                        <span v-else-if=" item.electrical_drawing.OPTION_2 == null">
                                            <span></span>
                                            <span></span>
                                        </span>

                                        <span v-if=" item.electrical_drawing.OPTION_2 == 'なし'">
                                            <span>E更新</span>
                                            <span>なし</span>
                                        </span>
                                    </div>
                                </td>
                                <!-- END OF ELECTRICAL DRAWING -->

                                <td v-show="viewMode"></td> <!-- ARRANGEMENT -->
                                <td v-show="viewMode"></td> <!-- TRIAL CODE -->
                                <!-- Updated Slice -->
                                <td v-show="viewMode" v-if="item.updated_at == null"> {{ item.updated_at }} </td>
                                <td v-show="viewMode" v-else-if="item.updated_at != null"> {{ item.updated_at.slice(0,10) }} </td>

                                <td v-show="viewMode"> {{ item.updated_by }} </td>
                                <!-- Deleted Slice -->
                                <td v-show="viewMode" v-if="item.deleted_at == null"> {{ item.deleted_at }} </td>
                                <td v-show="viewMode" v-else-if="item.deleted_at != null"> {{ item.deleted_at.slice(0,10) }} </td>
                                <!-- <td v-show="viewMode"> test </td> -->
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="17" style="font-size:16px;font-weight:bold;text-align:center;"><v-icon color="#616A6B">mdi-alert-circle</v-icon> No Records found!</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <!-- PAGINATION FOR VIEW TABLE -->

                    <!-- ----------- O L D ----------- -->
                    <!-- <div>
                        <v-pagination
                            v-model="page"
                            color="#34495e"
                            :length="pages"
                            :total-visible="6">
                        </v-pagination>
                    </div> -->

                    <!-- ----------- N E W ----------- -->
                    <div style="text-align: center; margin-top: 18px; height: 34px;">
                        <v-btn fab small @click="loadPreviousPage" :disabled="currentPage == 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                        <span v-if="lastPage <= 5 && viewtable.length >= 1">
                            <v-btn v-for="page in lastPage" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                        </span>
                        <span v-else-if="lastPage > 5 && viewtable.length >= 1">
                            <template v-if="currentPage >= 5">
                                <v-btn fab small @click="loadPage(1)" :disabled="currentPage == 1">1</v-btn>
                                <span>...</span>
                                <v-btn fab small @click="loadPage(currentPage - 1)" :disabled="currentPage == currentPage - 1">{{ currentPage - 1 }}</v-btn>
                                <v-btn fab small @click="loadPage(currentPage)" :disabled="currentPage == currentPage">{{ currentPage }}</v-btn>
                                <span v-if="currentPage != lastPage">...</span>
                                <v-btn v-if="currentPage != lastPage" fab small @click="loadPage(lastPage)" :disabled="currentPage == lastPage">{{ lastPage }}</v-btn>
                            </template>
                            <template v-else>
                                <v-btn v-for="page in 4" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                                <span>...</span>
                                <v-btn fab small @click="loadPage(lastPage)">{{ lastPage }}</v-btn>
                            </template>
                        </span>
                        <v-btn fab small @click="loadNextPage" :disabled="currentPage == lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
                    </div>
                </v-tab-item>

                <v-tab-item class="mt-2" v-if="loggedInUser.is_gc_user || loggedInUser.is_ichijo_user || loggedInUser.is_rulebook_user || loggedInUser.is_admin || loggedInUser.is_special_account || loggedInUser.japan_admin || loggedInUser.plan_control">
                    <!-- PLANNER VIEW TABLE -->
                    <v-simple-table class="mainTable" fixed-header height="55vh">
                        <thead>
                            <tr>
                                <th class="sticky-code" style="min-width: 200px !important;"> Customer Code </th>
                                <th class="sticky-revision"> Revision </th>
                                <th class="sticky-attach" width="20px"> Attachments </th>
                                <!-- <th class="text-center"> CAD Request<br>System </th> -->
                                <!-- <th style="cursor:pointer;" @click="sortBy()"> Created Date/Time  -->
                                <!-- ! UNCOMMENT THIS TO USE NEW SORTING THEN COMMENT THE TOP-->
                                <th class="sticky-created" style="cursor:pointer;" @click="hrdCreatedSortBy()"> Created Date/Time 
                                    <!-- <v-icon dark small>mdi-arrow-up-down-bold</v-icon> -->
                                    <!-- ! UNCOMMENT BELOW TO USE NEW SORTING THEN COMMENT THE TOP-->
                                    <v-icon dark small v-if="!createdSort">mdi-arrow-up-down-bold</v-icon>
                                    <v-icon dark small v-if="createdSort == 'DESC'">mdi-arrow-down-thin</v-icon>
                                    <v-icon dark small v-if="createdSort == 'ASC'">mdi-arrow-up-thin</v-icon>
                                </th>
                                <th class="th-sticky">Customer Name</th>
                                <th class="th-sticky"> Created By </th>
                                <th class="th-sticky"> Request Type </th>
                                <th class="th-sticky"> Express </th>
                                <th class="th-sticky"> Hrd Accept </th>
                                <!-- <th> Hrd Accepted Date </th> -->
                                <!-- <th style="cursor:pointer;" @click="plannerHrdAcceptSortBy()"> Hrd Accepted Date -->
                                <!-- ! UNCOMMENT THIS TO USE NEW SORTING THEN COMMENT THE TOP-->
                                <th style="cursor:pointer;" @click="hrdAcceptedDateSortBy()"> Hrd Accepted Date 
                                    <!-- <v-icon dark small>mdi-arrow-up-down-bold</v-icon> -->
                                    <!-- ! UNCOMMENT THIS TO USE NEW SORTING THEN COMMENT THE TOP-->
                                    <v-icon dark small v-if="!hrdAcceptSort">mdi-arrow-up-down-bold</v-icon>
                                    <v-icon dark small v-if="hrdAcceptSort == 'DESC'">mdi-arrow-down-thin</v-icon>
                                    <v-icon dark small v-if="hrdAcceptSort == 'ASC'">mdi-arrow-up-thin</v-icon>
                                </th>
                                <th class="th-sticky"> 設計受託契約 </th> 
                                <th class="th-sticky"> 最高高さ・見付面積・平均GL計算根拠 </th> 
                                <th class="th-sticky"> CAD図面 </th>
                                <th class="th-sticky"> カラー配置図 </th> 
                                <th class="th-sticky"> DXFデータ依頼 </th>
                                <th class="th-sticky"> カラーパース </th>
                                <th class="th-sticky"> ハウス プレゼンテーション </th>
                                <th class="th-sticky"> 仕様検討ツール </th> 
                                <th class="th-sticky"> WEB打ち合わせ用提案資料 </th> 
                                <th class="th-sticky"> カラー配置図 (測定点入) </th> 
                                <th class="th-sticky"> ALVS検討依頼 </th>
                                <th class="th-sticky"> 構造事前検討依頼 </th> 
                                <th class="th-sticky"> 提案電気図面依頼 </th> 
                                <th class="th-sticky"> 電気図面依頼 </th>
                                <th class="th-sticky"> Stop </th>
                                <th class="th-sticky"> 着手準備 </th> 
                            </tr>
                        </thead>
                        <tbody v-if="nextViewPage.length > 0">
                            <tr v-for="(item, i) in nextViewPage" :key="i" style="text-align:center;">
                                <!-- :style="[item.hrd_accept == 1 ? {backgroundColor : 'blue'}: '']" -->
                                <td class="sticky-view-code" > <v-btn text dense @click="goToMain(item.customer_code)">{{ item.customer_code }} </v-btn> <v-icon @click="copyControlNumber(item.customer_code)">mdi-content-copy</v-icon></td>
                                <td class="sticky-view-revision"> {{ item.revision_number }}</td>
                                <td class="sticky-view-attach">
                                    <span class="custom-svg svg-icon_folder pointer text-center" v-if="item.attachments.length > 0" @click="openFileAttDialog(item)">
                                    <!-- <p class="grey--text text--darken-4" > {{ item.request_attach_from }} </p></div> -->
                                    <v-icon color="primary"> mdi-file-table </v-icon></span>
                                </td>
                                <!-- <td v-if="item.from_version"> Version {{ item.from_version}} </td>
                                <td v-else></td> -->

                                <td class="sticky-view-created"> {{ item.created_at}} </td>
                                <td> {{ item.customer_name && item.customer_name.endsWith(' 様邸') ? item.customer_name : item.customer_name ? item.customer_name + ' 様邸' : ''}} </td>
                                <td> {{ item.created_by_code }} </td>
                                <td> {{ item.request_type }} </td>

                                <!-- EXPRESS PLAN -->
                                <td> 
                                    <v-chip
                                        class="ma-2"
                                        :color="item.express == '1' ? 'green' : 'red'"
                                        text-color="white"
                                        x-small
                                    >
                                    {{ item.express == '1' ? 'YES' : 'NO' }}
                                    </v-chip>
                                </td>
                                <!-- END OF EXPRESS PLAN -->

                                <!-- HRD ACCEPT -->
                                <td> 
                                    <v-chip
                                        class="ma-2"
                                        :color="item.hrd_accept == '1' ? 'blue' : 'red'"
                                        text-color="white"
                                        x-small
                                    >
                                    {{ item.hrd_accept == '1' ? 'YES' : 'NO' }}
                                    </v-chip><br>
                                    <span style="font-size:9.5px;" v-if="item.hrd_accept == 1"><center>{{ item.hrd_accepted_user_id != null ? item.hrd_accepted_user_id : '' }}</center></span>
                                    <!-- <span style="font-size:9px;" class="text-center" v-if="item.hrd_accepted_by != null">{{ item.hrd_accepted_by }}</span> -->
                                </td>
                                <!-- END -->

                                <!-- HRD ACCEPTED DATE -->
                                <td>
                                    {{ item.hrd_accepted_at }}
                                </td>
                                <!-- END -->

                                <!-- DESIGN CONTRACT -->
                                <td>
                                    <v-icon color="red" v-show="item.design_contract == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- CALCULATION BASIS -->
                                <td>
                                    <v-icon color="red" v-show="item.calculation_basis == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- REVISION TYPE -->
                                <td> 
                                    <v-icon color="red" v-show="item.cad == 1 || item.revision_type == 1 || item.revision_type == 2 || item.revision_type == 3 || item.revision_type == 4 || item.revision_type == 5
                                                            || item.revision_type == 7">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <td> 
                                    <!-- {{ item.site_layout }}  -->
                                    <span v-if="item.site_layout == '新規データN' && item.site_layout_option == 'option1'">
                                        <div style="font-size:10.5px;">{{ item.site_layout }}</div>
                                        <div style="font-size:8.5px;color:blue;margin:0 auto;">BOSS送信済み</div>
                                        <div style="font-size:8.5px;">
                                            屋外配管経路図 
                                            <span v-if="item.site_diagram == 'なし'" style="color:red;">{{ item.site_diagram }}</span>
                                            <span v-else style="color:blue;">{{ item.site_diagram }}</span>
                                        </div>
                                    </span>
                                    <span v-else-if="item.site_layout == '新規データN' && item.site_diagram != null">
                                        <div style="font-size:10.5px;margin:0 auto">{{ item.site_layout }}</div>
                                        <div style="color:red;font-size:8.5px;">屋外配管経路図 {{item.site_diagram}}</div>
                                    </span>
                                    <span v-else-if="item.site_layout == '新規データN'">
                                        <div style="height:18px; !important;font-size:10.5px;">{{ item.site_layout }}</div>
                                    </span>
                                    <span v-else-if="item.site_layout == '前回ベースP' && item.new_site_diagram != null">
                                        <div style="font-size:10.5px;margin:0 auto">{{ item.site_layout }}</div>
                                        <div style="color:red;font-size:8.5px;">屋外配管経路図 {{item.new_site_diagram}}</div>
                                    </span>
                                    <span v-else-if="item.site_layout != '新規データN' || item.site_layout != '前回ベースP'">
                                        <div style="font-size:10.5px;height:16px; !important;">{{ item.site_layout }}</div>
                                    </span>
                                    <span v-else>
                                        <div></div>
                                    </span>
                                </td>

                                <!-- DXF -->
                                <td> 
                                    <v-icon color="red" v-show="item.dxf_data_request == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- COLOR PERS -->
                                <td> 
                                    <v-icon color="red" v-show="item.color_pers == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- HP -->
                                <td>
                                    <v-icon color="red" v-show="item.house_presentation == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- SHIO REQUEST -->
                                <td>
                                    <v-icon color="red" v-show="item.shio_request == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- WEB DOCUMENT -->
                                <td>
                                    <!-- {{ item.web_documents }}  -->
                                    <span v-if="item.web_documents.length > 0" v-for="(ii, i) in item.web_documents" :key="i">
                                        <!-- <span v-if="ii.value == 1">①</span>
                                        <span v-if="ii.value == 2">②</span>
                                        <span v-if="ii.value == 3">③</span>
                                        <span v-if="ii.value == 4">④</span>
                                        <span v-if="ii.value == 5">⑤</span>
                                        <span v-if="ii.value == 6">⑥</span>
                                        <span v-if="ii.value == 7">⑦</span> -->
                                        <v-icon color="red" small>
                                            {{`mdi-numeric-${ii.value}-circle-outline`}}
                                        </v-icon>
                                    </span>
                                </td>
                                <!-- END OF WEB DOCUMENT -->

                                <!-- JIBAN -->
                                <td>
                                    <v-icon color="red" v-show="item.jiban_plan == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- ALVS -->
                                <td>
                                    <v-icon color="red" v-if="item.alvs == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                    <p class="font-weight-bold red--text" style="font-size:16px;" v-else> {{ item.alvs }} </p>
                                </td>
                                <!-- ALVS -->

                                <!-- STRUCTURAL REQUEST -->
                                <td>
                                    <div v-for="(subitem,index) in item.structural_request" :key="index">
                                        <!-- {{ subitem.OPTION_S }}/ {{ subitem.OPTION_W }} -->
                                        <span v-if="subitem.OPTION_1 == 'あり'">
                                            <v-icon color="red">
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </span>

                                        <span v-if="subitem.OPTION_S && subitem.OPTION_W">
                                            <!-- <v-icon color="red">
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon><br> --><br>
                                            {{ subitem.OPTION_S }} {{ subitem.OPTION_W }}
                                        </span>
                                        <span v-else-if="subitem.OPTION_S == null && subitem.OPTION_W">
                                            <!-- <v-icon color="red">
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon><br> --><br>
                                            {{ subitem.OPTION_W }}
                                        </span>
                                        <span v-else-if="subitem.OPTION_S && subitem.OPTION_W == null">
                                            <!-- <v-icon color="red">
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon><br> --><br>
                                            {{ subitem.OPTION_S }}
                                        </span>
                                        <!-- <span v-else-if="subitem.OPTION_S == null && subitem.OPTION_W == null">
                                            <v-icon color="red">
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </span> -->
                                    </div>
                                </td>
                                <!-- END -->

                                <!-- PDR -->
                                <td>
                                    <v-icon color="red" v-show="item.ED_PDR_TITLE != null">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- ELECTRICAL DRAWING -->
                                <td>
                                    <!-- electrical_drawing -->
                                    <div v-if="item.electrical_drawing">
                                        <span v-if=" item.electrical_drawing.OPTION_2 == 'あり'">
                                                <span>E更新</span>
                                                <span>あり</span>
                                        </span>
                                        <span v-else-if=" item.electrical_drawing.OPTION_2 == null">
                                            <span></span>
                                            <span></span>
                                        </span>

                                        <span v-if=" item.electrical_drawing.OPTION_2 == 'なし'">
                                            <span>E更新</span>
                                            <span>なし</span>
                                        </span>
                                    </div>
                                </td>
                                <!-- END OF ELECTRICAL DRAWING -->

                                <!-- STOP -->
                                <td>
                                    <v-icon color="red" v-show="item.stop == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->

                                <!-- FINAL -->
                                <td>
                                    <v-icon color="red" v-if="item.final_plan == 1">
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                    <v-icon color="red" v-else-if="item.final_plan == 2">
                                        mdi-numeric-1-circle-outline
                                    </v-icon>
                                    <v-icon color="red" v-else-if="item.final_plan == 3">
                                        mdi-numeric-2-circle-outline
                                    </v-icon>
                                </td>
                                <!-- END -->
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="15" style="font-size:16px;font-weight:bold;text-align:center;"><v-icon color="#616A6B">mdi-alert-circle</v-icon> No Records found!</td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <!-- PAGINATION FOR PLANNER VIEW TABLE -->
                    <!-- ----------- O L D ----------- -->
                    <!-- <div>
                        <v-pagination
                            v-model="page"
                            color="#34495e"
                            :length="pages"
                            :total-visible="6">
                        </v-pagination>
                    </div> -->

                    <!-- ----------- N E W ----------- -->
                    <div style="text-align: center; margin-top: 18px; height: 34px;">
                        <v-btn fab small @click="loadPreviousPage" :disabled="currentPage == 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                        <span v-if="lastPage <= 5 && viewtable.length >= 1">
                            <v-btn v-for="page in lastPage" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                        </span>
                        <span v-else-if="lastPage > 5 && viewtable.length >= 1">
                            <template v-if="currentPage >= 5">
                                <v-btn fab small @click="loadPage(1)" :disabled="currentPage == 1">1</v-btn>
                                <span>...</span>
                                <v-btn fab small @click="loadPage(currentPage - 1)" :disabled="currentPage == currentPage - 1">{{ currentPage - 1 }}</v-btn>
                                <v-btn fab small @click="loadPage(currentPage)" :disabled="currentPage == currentPage">{{ currentPage }}</v-btn>
                                <span v-if="currentPage != lastPage">...</span>
                                <v-btn v-if="currentPage != lastPage" fab small @click="loadPage(lastPage)" :disabled="currentPage == lastPage">{{ lastPage }}</v-btn>
                            </template>
                            <template v-else>
                                <v-btn v-for="page in 4" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                                <span>...</span>
                                <v-btn fab small @click="loadPage(lastPage)">{{ lastPage }}</v-btn>
                            </template>
                        </span>
                        <v-btn fab small @click="loadNextPage" :disabled="currentPage == lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
                    </div>
                </v-tab-item>

                <v-tab-item class="mt-2" v-if="loggedInUser.id == 1 || loggedInUser.id == 2 || loggedInUser.id == 15">
                    <!-- XML BUNDLE SCHEDULE TABLE -->
                    <div>
                        <v-simple-table class="mainTable" fixed-header height="55vh">
                            <thead>
                                <tr>
                                    <th> Customer Code </th>
                                    <th> HRD ID </th>
                                    <th> Revision </th>
                                    <th> Plan Type Name </th>
                                    <th> Boss Code </th>
                                    <th> HRD Process </th>
                                    <th> Receive Day </th>
                                    <th> Bracket Name </th>
                                    <th> Original Due Day </th>
                                    <th> Due Day </th> 
                                    <th> Finish Day </th> 
                                    <th> Sender </th>
                                    <th> Doc Arrangement </th> 
                                    <th> Remarks </th>
                                    <th> Pers HP Code </th>
                                    <th> House Type </th>
                                    <th> Created At </th> 
                                </tr>
                            </thead>
                            <tbody v-if="nextXmlBundlePage.length > 0">
                                <tr v-for="(item, i) in nextXmlBundlePage" :key="i" style="text-align:center;">
                                    <td>{{ item.code_number }}</td>
                                    <td>{{ item.HRD_ID }}</td>
                                    <td>{{ item.plan_number }}</td>
                                    <td>{{ item.plan_type_name }}</td>
                                    <td>{{ item.boss_code }}</td>
                                    <td>
                                        <v-chip
                                            class="ma-2"
                                            :color="item.hrdProcess == '1' ? 'green' : 'red'"
                                            text-color="white"
                                            x-small
                                        >
                                        {{ item.hrdProcess == '1' ? 'YES' : 'NO' }}
                                        </v-chip>
                                    </td>
                                    <td>{{ item.received_day }}</td>
                                    <td>{{ item.bracket_name }}</td>
                                    <td>{{ item.original_due_day }}</td>
                                    <td>{{ item.due_day }}</td>
                                    <td>{{ item.finish_day }}</td>
                                    <td>{{ item.sender }}</td>
                                    <td>{{ item.doc_arrangement }}</td>
                                    <td><v-icon @click="openRemarksDialog(item.remarks)" large color="primary">mdi-dots-horizontal</v-icon></td>
                                    <td>{{ item.pers_hp_code }}</td>
                                    <td>{{ item.house_type_name_2 }}</td>
                                    <td>{{ item.created_at }}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="17" style="font-size:16px;font-weight:bold;text-align:center;"><v-icon color="#616A6B">mdi-alert-circle</v-icon> No Records found!</td>
                            </tr>
                        </tbody>
                        </v-simple-table>  
                        <!-- PAGINATION FOR XML BUNDLE TABLE -->
                        <!-- ----------- O L D ----------- -->
                        <!-- <v-pagination
                            v-model="xmlPage"
                            :length="xmlBundlePages"
                            color="#34495e"
                            :total-visible="6"
                        ></v-pagination> -->

                        <!-- ----------- N E W ----------- -->
                        <div style="text-align: center; margin-top: 18px; height: 34px;">
                            <v-btn fab small @click="loadPreviousPage" :disabled="currentPage == 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                            <span v-if="lastPage <= 5 && XmlData.length >= 1">
                                <v-btn v-for="page in lastPage" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                            </span>
                            <span v-else-if="lastPage > 5 && XmlData.length >= 1">
                                <template v-if="currentPage >= 5">
                                    <v-btn fab small @click="loadPage(1)" :disabled="currentPage == 1">1</v-btn>
                                    <span>...</span>
                                    <v-btn fab small @click="loadPage(currentPage - 1)" :disabled="currentPage == currentPage - 1">{{ currentPage - 1 }}</v-btn>
                                    <v-btn fab small @click="loadPage(currentPage)" :disabled="currentPage == currentPage">{{ currentPage }}</v-btn>
                                    <span v-if="currentPage != lastPage">...</span>
                                    <v-btn v-if="currentPage != lastPage" fab small @click="loadPage(lastPage)" :disabled="currentPage == lastPage">{{ lastPage }}</v-btn>
                                </template>
                                <template v-else>
                                    <v-btn v-for="page in 4" :key="page" fab small @click="loadPage(page)" :disabled="currentPage == page" class="ml-1 mr-1">{{ page }}</v-btn>
                                    <span>...</span>
                                    <v-btn fab small @click="loadPage(lastPage)">{{ lastPage }}</v-btn>
                                </template>
                            </span>
                            <v-btn fab small @click="loadNextPage" :disabled="currentPage == lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
                        </div>
                    </div>
                </v-tab-item>
                
                <v-tab-item class="mt-2">
                    <!-- CAD依頼受付状況 -->
                    <v-toolbar flat>
                        <v-btn @click="getPreviousWeek('prev')" icon>
                            <v-icon x-large>mdi-arrow-left-bold-circle-outline</v-icon>
                        </v-btn>
                        <v-spacer/>
                        <v-btn :disabled="disableForward" @click="getPreviousWeek('for')" icon>
                            <v-icon x-large>mdi-arrow-right-bold-circle-outline</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div>
                        <v-simple-table class="mainTable" height="55vh">
                            <thead>
                                    <!-- 1st row -->
                                <tr>
                                    <th colspan="2" rowspan="3" class="newTable">
                                        <div>
                                        送信日時<br>
                                        【午前】前日18:30~12:00<br>
                                        【午後】12:00~18：30
                                        </div>
                                    </th>
                                    <th v-for="(item, ii) in sevenDaysHeader" :key="ii" class="newTable" rowspan="1" colspan="2">{{(item.shortCut)}}</th>
                                </tr>

                                    <!-- 2nd row -->
                                <tr>
                                    <th  v-for="(item, ii) in sevenDaysHeader" :key="ii" class="newTable" rowspan="1" colspan="2">{{item.jap}} ({{item.day}})</th>
                                </tr>

                                    <!-- 3rd row -->
                                <tr>
                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                    <th class="newTable" rowspan="1">午前 (AM)</th>
                                    <th class="newTable" rowspan="1">午後 (PM)</th>

                                </tr>

                                    <!-- 4th row -->
                                <tr v-if="loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1">
                                    <th class="newTable" colspan="2" rowspan="2">Bracket Covered</th>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <th :key="index * 14 + 4">{{ item.bracket_time_am }}</th>
                                        <th :key="index * 14 + 5">{{ item.bracket_time_pm }}</th>
                                    </template>
                                </tr>
                                    <!-- 5th row -->
                                <tr v-if="loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1">
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <th class="newTable" :key="index * 14 + 4">{{ item.bracket_am }}</th>
                                        <th class="newTable" :key="index * 14 + 5">{{ item.bracket_pm }}</th>
                                    </template>
                                </tr>
                                    <!-- 6th row -->
                                <tr v-if="loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1">
                                    <th class="newTable" colspan="2" rowspan="2">Boss Due Day</th>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <th class="newTable" :key="index * 14 + 4">{{ item.due_day_am }}</th>
                                        <th class="newTable" :key="index * 14 + 5">{{ item.due_day_pm }}</th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr v-for="(item, i) in searchInXml" :key="i" style="text-align:center;"> -->
                                    <!-- NORMAL BUNDLE -->
                                <tr style="text-align:center;">
                                    <td class="newTableTD" rowspan="2">CAD依頼受信数</td>
                                    <td class="newTableTD">CAD変更あり</td>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <td class="newTableTD" :key="index * 14 + 4">{{ item.total_count_am_003 }}</td>
                                        <td class="newTableTD" :key="index * 14 + 5">{{ item.total_count_pm_003 }}</td>
                                    </template>
                                </tr>
                                <tr>
                                    <td class="newTableTD">CAD変更なし</td>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <td class="newTableTD" :key="index * 14 + 4">{{ item.total_count_am }}</td>
                                        <td class="newTableTD" :key="index * 14 + 5">{{ item.total_count_pm }}</td>
                                    </template>
                                </tr>
                                
                                <!-- EXPRESS -->
                                <tr style="text-align:center;">
                                    <td class="newTableTD" rowspan="2">即日依頼受信数</td>
                                    <td class="newTableTD">CAD変更あり</td>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <td class="newTableTD" :key="index * 14 + 4">{{ item.express_count_am_003 }}</td>
                                        <td class="newTableTD" :key="index * 14 + 5">{{ item.express_count_pm_003 }}</td>
                                    </template>
                                </tr>
                                <tr>
                                    <td class="newTableTD">CAD変更なし</td>
                                    <template v-for="(item, index) in sevenDaysHeader">
                                        <td class="newTableTD" :key="index * 14 + 4">{{ item.express_count_am }}</td>
                                        <td class="newTableTD" :key="index * 14 + 5">{{ item.express_count_pm }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </v-simple-table>   
                    </div> 
                </v-tab-item>

                <!-- <v-tab-item class="mt-2" v-if="loggedInUser.id == 1 || loggedInUser.id == 15"> -->
                <v-tab-item class="mt-2" v-if="loggedInUser.id == 1 || loggedInUser.id == 2">
                    <!-- TABLE FOR CHECKING OF DATA THAT ARE NOT UPLOADED TO BOSS OR LOCAL SERVER -->
                    <center>
                        <div style="width: 650px !important;">
                            <!-- <v-toolbar flat>
                                <v-spacer/>
                                <v-radio-group
                                    v-model="notUploadedOption"
                                    row
                                >
                                <v-radio
                                    label="Not Uploaded to Boss"
                                    value="boss"
                                ></v-radio>
                                <v-radio
                                    label="Not saved to hrdapps49"
                                    value="radio-2"
                                ></v-radio>
                                </v-radio-group>
                            </v-toolbar> -->
                            <v-simple-table class="mainTable" fixed-header height="55vh">
                                <thead>
                                    <tr>
                                        <th>Customer Code</th>
                                        <th>Revision Number</th>
                                        <th>Action</th>
                                    </tr>
                                    <!-- <tr>
                                        <th>Customer Code</th>
                                        <th>Revision Number</th>
                                    </tr> -->
                                </thead>
                                <tbody v-if="notUploaded.length > 0">
                                    <tr v-for="(item, index) in notUploaded" :key="index">
                                        <td>{{ item.customer_code }}</td>
                                        <td>{{ item.revision_number }}</td>
                                        <td>
                                            <v-btn icon @click="openXmlData(item)">
                                                <v-icon color="primary">mdi-send</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <!-- <tr v-for="(group, ii) in notUploaded" :key="ii + '1'">
                                        <td>{{ ii }}</td>
                                    </tr> -->
                                    <!-- <tr v-for="(item, index) in group" :key="index">
                                        <td> {{ item.customer_code }} </td>
                                        <td> {{ item.revision_number }} </td>
                                    </tr> -->
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="12" style="font-size:16px;font-weight:bold;text-align:center;"><v-icon color="#616A6B">mdi-alert-circle</v-icon> No Records found!</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>  
                        </div>
                    </center>
                </v-tab-item>
            </v-tabs>

            <!-- DIALOG FOR REMARKS(JSON) -->
            <v-dialog v-model="remarksDialog" max-width="400" height="600px">
                <div>
                    <v-card>
                        <v-card-title class="overline">Remarks</v-card-title>
                        <v-card-text class="mt-2">
                            <div v-if="remarksData">
                                <v-simple-table fixed-header height="550px">
                                    <tbody>
                                        <tr v-for="(value, key) in remarksData" :key="key">
                                            <td style="background-color: #E0E0E0;">
                                                {{ key }}
                                            </td>
                                            <td style="width: 20px !important;font-size:15px !important; border: 1px solid black !important; white-space: nowrap;">{{ value }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table><br>
                            </div>

                            <div v-else class="mt-5 text-center">
                                <span>No data available</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <!-- DIALOG FOR NOT SAVED REMARKS(JSON) -->
            <v-dialog v-model="notSavedRemarksDialog" width="500px">
                <div>
                    <v-card>
                        <v-card-title class="overline">Remarks</v-card-title>
                        <v-card-text class="mt-2">
                            <div v-if="remarksNotSavedData">
                                <v-simple-table fixed-header>
                                    <tbody>
                                        <tr v-for="(value, key) in remarksNotSavedData" :key="key">
                                            <td style="background-color: #E0E0E0;">
                                                {{ key }}
                                            </td>
                                            <td>{{ value }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table><br>
                            </div>

                            <div v-else class="mt-5 text-center">
                                <span>No data available</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>

            </v-dialog>

            <!-- NOT SAVED TO LOCAL DIALOG -->
            <v-dialog v-model="notSavedDialog">
                <div>
                    <v-card>
                        <v-card-title class="overline">Boss Data to be Sent
                            <v-spacer/>
                            <v-btn dense dark color="success">RESEND</v-btn>                  
                        </v-card-title>
                        <v-card-text class="mt-2">
                            <div v-if="xmlDataToSave">
                                <v-simple-table class="mainTable" fixed-header>
                                    <thead>
                                        <tr>
                                            <th> Customer Code </th>
                                            <th> HRD ID </th>
                                            <th> Revision </th>
                                            <th> Plan Type Name </th>
                                            <th> Boss Code </th>
                                            <th> HRD Process </th>
                                            <th> Receive Day </th>
                                            <th> Bracket Name </th>
                                            <th> Original Due Day </th>
                                            <th> Due Day </th> 
                                            <th> Finish Day </th> 
                                            <th> Sender </th>
                                            <th> Doc Arrangement </th> 
                                            <th> Remarks </th>
                                            <th> Pers HP Code </th>
                                            <th> House Type </th>
                                            <th> Created At </th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in xmlDataToSave" :key="i" style="text-align:center;">
                                            <td>{{ item.code_number }}</td>
                                            <td>{{ item.HRD_ID }}</td>
                                            <td>{{ item.plan_number }}</td>
                                            <td>{{ item.plan_type_name }}</td>
                                            <td>{{ item.boss_code }}</td>
                                            <td>
                                                <v-chip
                                                    class="ma-2"
                                                    :color="item.hrdProcess == '1' ? 'green' : 'red'"
                                                    text-color="white"
                                                    x-small
                                                >
                                                {{ item.hrdProcess == '1' ? 'YES' : 'NO' }}
                                                </v-chip>
                                            </td>
                                            <td>{{ item.received_day }}</td>
                                            <td>{{ item.bracket_name }}</td>
                                            <td>{{ item.original_due_day }}</td>
                                            <td>{{ item.due_day }}</td>
                                            <td>{{ item.finish_day }}</td>
                                            <td>{{ item.sender }}</td>
                                            <td>{{ item.doc_arrangement }}</td>
                                            <td><v-icon @click="openNotSavedRemarksDialog(item.remarks)" large color="primary">mdi-dots-horizontal</v-icon></td>
                                            <td>{{ item.pers_hp_code }}</td>
                                            <td>{{ item.house_type_name_2 }}</td>
                                            <td>{{ item.created_at }}</td>
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>  
                            </div>

                            <div v-else class="mt-5 text-center">
                                <span>No data available</span>
                            </div>
                            <div>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>

            </v-dialog>
        </v-container>
        
        <!-- Dialogs -->
            <!-- ADD TO BOSS DIALOG MANUL -->
            <v-dialog width="300px" v-model="addToBossDialog">
                <div>
                    <v-card>
                        <v-card-title>ADD TO BOSS</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="hrdIdAdd" outlined dense label="HRD ID"></v-text-field>
                                    <v-text-field v-model="bossCustomerCode" outlined dense label="Customer Code"></v-text-field>
                                    <v-text-field v-model="bossPlannerCode" outlined dense label="Planner Code"></v-text-field>
                                    <v-text-field v-model="bossPlanNumber" outlined dense label="Plan Number"></v-text-field>
                                    <v-text-field v-model="bossPlanType" outlined dense label="Boss Code"></v-text-field>
                                    <v-text-field v-model="bossReceivedDay" placeholder="YYYY/MM/DD HH:MM" outlined dense label="Received Day"></v-text-field>
                                    <v-text-field v-model="bossFinishPlanDay" placeholder="YYYY/MM/DD HH:MM" outlined dense label="Finish Plan Day(due_day)"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="addToBoss()" block dark>ADD</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-dialog>
            <!-- DELETE TO BOSS DIALOG -->
            <v-dialog width="300px" v-model="deleteToBossDialog">
                <div>
                    <v-card>
                        <v-card-title>DELETE TO BOSS</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="hrdIdDel" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="deleteToBoss()" block dark>DELETE</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-dialog>
            <!-- DELETE FOR ONLY ME -->
            <v-dialog width="300px" v-model="deleteManualDialog">
                <div>
                    <v-card>
                        <v-card-title>TRASH</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="trashCustomerCode" counter="12" outlined dense label="Customer Code"></v-text-field>
                                    <v-text-field v-model="hrdIdTrash" outlined dense label="HRD ID"></v-text-field>
                                    <v-text-field v-model="trashPlanType" outlined dense label="Boss Code"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="deleteManual()" block dark>DELETE</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-dialog>
            <!-- BOSS SCHEDULE -->
            <v-dialog v-model="bossSchedDialog" max-width="450" persistent>
                <div>
                    <v-card>
                        <v-card-title class="mb-2">
                            <span class="headline">図面仕上がり予定表</span>
                            <v-spacer/>
                            <v-icon medium color="red" @click="bossSchedDialog = false">mdi-close</v-icon>
                        </v-card-title>
                        <v-card-text>
                            <div v-if="schedule.length > 0">
                                <v-simple-table class="mainTable" width="400px">
                                    <thead>
                                        <tr>
                                            <th>FILE TYPE</th>
                                            <th>DUE DAY</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in schedule" :key="index">
                                            <td>{{ item.plan_type }}</td>
                                            <td>{{ item.due }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                            </div>
                            
                            <div v-else class="mt-5 text-center">
                                <span>No data available</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

            <v-dialog v-model="fileAttDialog" max-width="1000" persistent>

                <div class="text-center" style="font-family:Sans-serif">
                    <center>
                        <v-overlay v-model="overlay">
                            <v-progress-circular
                                indeterminate
                                :size="120"
                                :width="3">
                            </v-progress-circular>Loading,please wait...
                        </v-overlay>
                    </center>
                </div>

                <v-card width="1000px">
                    <v-card-title>
                        <span class="headline"> File Attachments </span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-container>
                        <v-card-text>
                            <table class="attachmentViewTable">
                                <thead>
                                    <tr>
                                        <th> Column </th>
                                        <th> File Name </th>
                                        <th> File Type </th>
                                        <th> No. of pages </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in attDialogList" :key="index">
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''"> {{ item.att_column_name }} </td>
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''"> {{ item.filename }} </td>
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center"> {{ item.fileType }} </td>
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center" v-if="item.no_of_pages != 0"> {{ item.no_of_pages }} </td>
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center" v-else> N/A </td>
                                        <td :style="item.att_column_name == 'CAD依頼書結合ファイル' ? 'background-color: #FFA4B6;' : item.fileType.toLowerCase() != 'pdf' ? 'background-color: #8ecae6;' : ''" class="text-center">
                                            <center>
                                                <v-icon color="primary" @click="viewFile(item.id)">mdi-file-find</v-icon>
                                                <v-icon color="success" @click="downLoadFile(item.id, 'single')">mdi-download-outline</v-icon>
                                                <v-checkbox class="mb-0" style="margin-left:25% !important; display:block !important;" v-model="item.selectedCheckBox"  @change="multipleCheckBox(item)"></v-checkbox>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right font-weight-bold" colspan="3">Total No. of PDF pages attached : </td>
                                        <td class="text-center font-weight-bold">{{ totalPages }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="editRecord.hrd_accept == 1 && editRecord.revision_type != '10'" dark color="#1B5E20" :style="{ 'pointer-events': bossSchedBtn ? 'none' : 'auto', opacity: bossSchedBtn ? 0.5 : 1 }" small @click="openBossSchedDialog()">図面仕上がり予定表</v-btn>
                            <!-- <v-btn dark @click="hrdAcceptAtt()" v-if="defaultTab == 0 && (loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1) && editRecord.hrd_accept == null" small
                                    v-show="loggedInUser.is_hrd_viewer != 1 || loggedInUser.is_hrd_requestor != 1">HRD ACCEPT</v-btn> -->
                            <!-- <v-btn dark @click="openDialogForRegistration(editRecord)" v-if="defaultTab == 0 && (loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1) && editRecord.hrd_accept == null" small
                                    :color="acceptBtn ? 'indigo' : 'grey'" v-show="loggedInUser.is_hrd_viewer != 1 || loggedInUser.is_hrd_requestor != 1">HRD ACCEPT</v-btn> -->
                                    <!-- :style="{'pointer-events': !regBtn ? 'none' : 'auto', opacity: !regBtn ? 0.7 : 1}" -->
                                    <!-- :color="regBtn ? 'success' : 'grey'" -->
                            <v-btn @click="openDialogForRegistration(editRecord, false)" v-if="defaultTab == 0 && (loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1) && (editRecord.sent_to_boss == null || editRecord.sent_to_boss == '0') && editRecord.revision_type != '10'" small dark :style="{'pointer-events': !regBtn ? 'none' : 'auto', opacity: !regBtn ? 0.7 : 1}"
                                    :color="regBtn ? 'success' : 'grey'">REGISTER </v-btn>
                            <v-btn dark @click="openDialogForRegistration(editRecord, true)" v-if="defaultTab == 0 && (loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1) && editRecord.hrd_accept == null && editRecord.revision_type != '10'" small :style="{'pointer-events': !acceptBtn ? 'none' : 'auto', opacity: !acceptBtn ? 0.7 : 1}"
                                    :color="acceptBtn ? 'indigo' : 'grey'" v-show="loggedInUser.is_hrd_viewer != 1 || loggedInUser.is_hrd_requestor != 1">HRD ACCEPT</v-btn>
                            <v-btn dark color="green" :style="{ 'pointer-events': repdfBtn ? 'none' : 'auto', opacity: repdfBtn ? 0.5 : 1 }" @click="toggleUpdateCadRequest()" v-show="loggedInUser.is_hrd_viewer != 1 && editRecord.revision_type != '10'" small>結合PDFの作成</v-btn>
                            <v-btn dark color="blue" v-if="editRecord.revision_type != '10'" :style="{ 'pointer-events': !downloadBtn ? 'none' : 'auto', opacity: !downloadBtn ? 0.5 : 1 }" small @click="downLoadMultiple()">Download</v-btn>
                            <v-btn dark color="red" small @click="closeFileAtt()"> キャンセル </v-btn>
                        </v-card-actions>
                    </v-container>
                    <!-- :style="{'pointer-events': !acceptBtn ? 'none' : 'auto', opacity: !acceptBtn ? 0.7 : 1}"
                    :color="acceptBtn ? 'indigo' : 'grey'" -->
                </v-card>
            </v-dialog>
            <!-- <v-dialog v-model="StoreDialog" max-width="800" persistent>
                <v-form id="Store" ref="Store" @submit.prevent="Store">
                    <v-card>
                        <v-card-title>
                            <span class="headline"> PLANNER BASIC INFO </span>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <template>
                                        <v-col cols="6">
                                            <v-text-field
                                                name="name"
                                                label="お客様コード"
                                                outlined
                                                dense
                                                class="required"
                                                :rules="rules.required">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                name="name"
                                                label="建物タイプ"
                                                outlined
                                                dense
                                                class="required"
                                                :rules="rules.required">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-text-field
                                                name="remarks"
                                                label="備考欄"
                                                outlined
                                                dense>
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-autocomplete
                                                    :items="['一般仕様', '準防火仕様', '準耐火仕様']"
                                                    dense
                                                    outlined
                                                    label="防火仕様"
                                                    class="required"
                                                    :rules="rules.required">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-autocomplete
                                                    :items="['240', '260+']"
                                                    dense
                                                    outlined
                                                    label="矩計"
                                                    class="required"
                                                    :rules="rules.required">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-autocomplete
                                                :items="['耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)', '耐水害（浮上)']"
                                                dense
                                                outlined
                                                label="耐水害住宅">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-autocomplete
                                                    :items="['あり', 'なし']"
                                                    dense
                                                    outlined
                                                    label="２倍耐震"
                                                    class="required"
                                                    :rules="rules.required">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-autocomplete
                                                    :items="['あり', 'なし']"
                                                    dense
                                                    outlined
                                                    label="高防火外壁"
                                                    class="required"
                                                    :rules="rules.required">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="上棟予定日"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label=" 加工依頼日"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="仮契約日"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="本契約日"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                            
                                        <v-col cols="12">
                                            <v-divider> </v-divider>
                                        </v-col>
                                        <v-col cols="12">
                                            <span class="overline font-weight-black">敷地情報</span>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-autocomplete
                                                name="name"
                                                label="建築地"
                                                outlined
                                                dense
                                                :items="['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県']"
                                                class="required"
                                                :rules="rules.required"
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="県コード"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="電力会社名"
                                                outlined
                                                dense
                                                class="required"
                                                :rules="rules.required"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="垂直積雪量"
                                                outlined
                                                dense
                                                suffix="cm"
                                                class="required"
                                                :rules="rules.required"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="基準風速"
                                                outlined
                                                dense
                                                suffix="m/s"
                                                class="required"
                                                :rules="rules.required"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field
                                                name="name"
                                                label="海岸からの距離"
                                                outlined
                                                dense
                                                suffix="km"
                                                class="required"
                                                :rules="rules.required"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-autocomplete
                                                name="name"
                                                label="積雪区分"
                                                outlined
                                                dense
                                                :items="['一般地域', '多雪区域内']"
                                                class="required"
                                                :rules="rules.required"
                                            ></v-autocomplete>
                                        </v-col>

                                    </template>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn  small text  type="submit"> 送信 </v-btn>
                            <v-btn  small text  @click="StoreDialog = false"> キャンセル </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog> -->


        <app-snackbar :snackbar="snackbar" @toggleSnackBar="toggleSnackBar"></app-snackbar>



        <!-- Floating Action Buttons  -->
        <!-- <v-btn
            color="primary"
            class="float-add"
            elevation="2"
            fab
            fixed
            right
            data-cad-step="3"
            @click="StoreDialog = true"
        >
        <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
            color="primary"
            elevation="2"
            fab
            absolute
            fixed
            class="float-edit"
        right
        >
        <v-icon>mdi-pencil</v-icon>
        </v-btn> -->

        <dialog-boss-list
            v-if="fileAttDialog"
            @toggleBossListDialog="toggleBossListDialog"
            @confirmBoss="confirmBoss"
            :dialog="dialogBossList">
        </dialog-boss-list>


        <!-- <app-footer :myProp="toolbar" :items="defaultTab === 0 || defaultTab === 1 ? viewtable.length :  defaultTab === 2 ? XmlData.length : 0"></app-footer> -->
        
        <!-- <app-footer :myProp="toolbar" :items="totalRecord"></app-footer> -->

        <v-footer app fixed tile dense inset v-if="defaultTab != 3 && defaultTab != 4">
            <span class="caption pt-0">Rows per page : 20</span>
            <span class="pt-0 pl-5" style="font-weight: bolder; font-size: small; letter-spacing: 2px" v-if="totalRecord > 0">{{ totalFrom }} - {{ totalTo }} of {{ totalRecord }}</span>
            <span class="pt-0 pl-5" style="font-weight: bolder; font-size: small; letter-spacing: 2px" v-else>-</span>
        </v-footer>
        </div>
        <!-- NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28) -->
        <!-- SYSTEM UNDERMAINTENANCE MESSAGE -->
        <div v-if="isUnderMaintenance == 2" class="centered-div">
            <v-card height="300px" width="800px" elevation="0">
                <v-card-text class="d-flex justify-center align-center" style="height: 100%;">
                    <div class="text-center">
                        <h1 style="color: #A6AEBF">システムメンテナンス中</h1>
                        <br />
                        <h1 style="color: #A6AEBF" class="ma-3">下記時間帯はシステムの使用ができません。</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">{{japanDate}} {{japanTime}}（日本時間）</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">※{{philippineTime}}（フィリピン時間）</h1>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ExcelJS from 'exceljs';
import Swal from 'sweetalert2';
import moment from 'moment';
import AWS from 'aws-sdk';
import { saveAs } from 'file-saver';
import JSZip, { forEach } from 'jszip';
import copy from "copy-to-clipboard";
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../modules/ToolbarMenu.vue';
import Footer from '../modules/Footer.vue';
import Snackbar from '../modules/SnackBar.vue'
import { PDFDocument, PDFPage } from 'pdf-lib';

// Dialogs
import DialogBossList from '../components/main-page-modules/DialogBossList';

// EXTERNAL JS
import { 
    generateHRDID, 
    getZumenType, 
    getZumenTypeMultiple,
    getBundleSchedule, 
    saveToXML, 
    updateXML, 
    sendToBoss, 
    updateBossCadRequest, 
    removeHrdAccept
} from './ExternalJS/BossCodeUploading.js'

import {
    getAllBossCode,
    newBossRegister,
    json_remarks
} from './ExternalJS/BossRegister.js'
// import { method } from 'lodash';

export default {
    components: {
        "app-toolbar" : ToolbarMenu,
        "app-footer" : Footer,
        'app-snackbar': Snackbar,

        'dialog-boss-list' : DialogBossList,

    },
    data(){
        return {
            isUnderMaintenance: null,
            japanDate: '',
            japanTime: '',
            philippineTime: '',
            // dialog
            totalItems: 0,
            xmlPage: 1,
            toastVisible: false,
            value: 0,
            query: false,
            show: true,
            interval: 0,
            dialogBossList: false,

            getTabName : null,
            hrdIdDel: null,
            hrdIdAdd : null,
            bossCustomerCode : null,
            bossPlannerCode : null,
            bossPlanNumber : null,
            bossPlanType : null,
            bossReceivedDay : null,
            bossFinishPlanDay : null,
            addToBossDialog: false,
            deleteToBossDialog: false,
            deleteManualDialog: false,
            trashPlanType: null,
            hrdIdTrash: null,
            trashCustomerCode: null,
            basicInfo: null,
            notSavedRemarksDialog: false,
            notUploadedOption: 'boss',
            sortOrder: 'asc',
            hrdAcceptSortOrder : 'asc',
            hrdCreatedSortOrder : 'asc',
            hrdAcceptDateSortOrder : 'asc',
            xmlDataToSave: [],
            sevenDaysHeader: [],
            cadScheduleData: [],
            bossSchedDialog: false,
            XmlData: [],
            remarksDialog: false,
            notSavedDialog: false,
            remarksData: {},
            repdfBtn: false,
            bossSchedBtn: false,
            defaultTab: 0,
            totalRecord: 0,
            users : [],
            filterCreated : [],
            customerFileCode : [],
            multipleFile : [],
            reminder: true,
            page: 1,
            snackbar:{
                    text: '',
                    show: false,
            },
            filterCreatedBy : null,
            overlay: false,
            filterDateSelection: "Filter By Date",
            // columnRestriction: true,
            filterDate : [
                "Show All",
                "Filter By Date"
            ],
            search: '',
            searchXml: '',
            HrdAcceptSelection: [
                "All",
                "Accepted",
                "Not Yet Accepted"
            ],
            ExpressPlanSelection: [
                "All",
                "Express",
                "Not Express"
            ],
            // dateFrom : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            currentDate : new Date(),
            dateFrom : '',
            dateFromMenu : false,
            dateTo : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateToMenu : false,
            // overlay : false,
            toolbar: {
                title: 'VIEW TABLE',
                // title2: 'PLANNER VIEW TABLE',
                test: 'test',
                view: true,
                back: false,
                filter: false,
            },
            fileAttDialog: false,
            StoreDialog: false,
            countPageUpdate: 0,
            row: null,
            viewtable: [],
            editRecord: {},
            // basicInfor: {},
            attDialogList : [],
            pathName : null,
            mergedFilename : null,
            totalPages : 0,
            expressSelect : "All",
            hrdAcceptSelect: "Not Yet Accepted",
            downloadBtn: false,
            acceptBtn : false,
            regBtn : false,
            newCadRequest:{},
            updateStatus: null,
                        // BOSS CODE REGISTRATION AND UPLOADING
            env: {
				response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
				request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
			},
            boss_data: {},
            schedule: [],
            dateToday: moment(),
            disableForward: true,
            notUploaded: [],
            remarksNotSavedData: [],
            // brackets: [
            //     '0',
            //     '1',
            //     '2-1',
            //     '2-2',
            //     '3-1',
            //     '3-2',
            //     '3-3'
            // ]
            plannerDetails : null,
            salesmanDetails : null,
            houseTypeFromSocket : null,
            dataFromCi : null,
            powerId : null,
            accept: false,
            basicInfo: null,
            xmlSkip: 0,
            xmlLimit: 20,

            currentPage : 1,
            lastPage : null,
            metaData: [],
            totalFrom: 0,
            totalTo: 0,
            next_page_url: null,
            createdSort: null,
            hrdAcceptSort: null,
            constructionCode : '',
        }
    },

        sockets: { 
        // NOTE : SOCKET 
        updateReceived: async function(socket) {
            this.plannerDetails = null;
            this.salesmanDetails = null;
            this.houseTypeFromSocket = null;
            this.dataFromCi = null;
            this.powerId = null;

            // if(this.$router.path == '/home'){
                if(socket && socket.dispatchType == this.env.response && socket.functionType == 'sendToBossDynamic' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){

                    // if(socket.data.status != 'DELETE'){
                        if(socket.data.sentDataStat){
                            await updateBossCadRequest(socket.data.sentDataStat, socket.data.receivedData, this.updateStatus);
                            Swal.fire({
                                icon: 'success',
                                title: `Plan deleted successfully!`,
                            }).then(() => {
                            })
                            await this.getView();
                            this.loader = false;
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to boss failed.`,
                                text: 'Kindly reupload data.',
                            }).then(async () => {
                                await removeHrdAccept(socket.data.receivedData);
                                await this.getView();
                                this.loader = false;
                            })

                        }
                        
                    // }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'sendToBossDynamicRes' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){
                    // if(socket.data.status != 'DELETE'){
                        // console.log(socket)

                        if(socket.data.sentDataStat){
                            await updateBossCadRequest(socket.data.sentDataStat, socket.data.receivedData, this.updateStatus);
                            if(this.updateStatus != 'DELETE' && !this.isNewExpress){
                                if(!this.accept) await this.saveToLocal();
                                // else{
                                    Swal.fire({
                                        icon: 'success',
                                        title: `Successfully uploaded to boss`,
                                    }).then(() => {
                                    })
                                // }
                            }
                            await this.getView();
                            this.overlay = false;
                        }else{
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to boss failed.`,
                                text: 'Kindly reupload data.',
                            }).then(async () => {
                                await removeHrdAccept(socket.data.receivedData);
                                await this.getView();
                                this.overlay = false;
                            })

                        }
                        
                    // }
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'bossScheduleResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){
                    await this.sendToBackend(socket.data);
                    // console.log(socket.data.outputData,'output')
                    this.plannerDetails = socket.data.plannerDetails;
                    this.salesmanDetails = socket.data.salesmanDetails;
                    this.houseTypeFromSocket = socket.data.houseType;
                    this.dataFromCi = socket.data.CIdata;
                    this.powerId = socket.data.power;
                    this.$store.state.sched_header = socket.data.outputData.bracket_name;
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'bossScheduleSavingResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){
                    // ? SAVE BRACKET TO CAD_REQUESTS DATABASE
                        axios({
                            method: 'post',
                            url: 'api/saveBracketToCad',
                            data: {
                                sched: socket.data.outputData,
                                cad: socket.data.latestData
                            }
                        }).then(({data}) => {
                            // console.log(data)
                            // this.getView();
                        })
                }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'saveToLocalResponse' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){
                    // ? CHECK IF THE SAVING TO LOCAL IS SUCCESS
                        if(socket.data.result.xmlcad_v3_id || socket.data.result.xmlcad_v3_id == null){
                            // Swal.fire({
                            //     icon: 'success',
                            //     title: `Successfully uploaded to boss`,
                            // }).then(async () => {
                                try {
                                    await axios({
                                        method: "POST",
                                        url: "api/update_xml_cad",
                                        data: {
                                            xmlv3_id : socket.data.result.xmlcad_v3_id,
                                            local_status: true,
                                            cad: socket.data.latest,
                                        }
                                    })
                                    await this.getView();
                                    this.overlay = false;
                                } catch (error) {
                                    await removeHrdAccept(socket.data.latest);
                                    await this.getView();
                                    this.overlay = false;
                                }

                            // })
                        }else{
                    // ? ELSE IF SAVING FAILED, REMOVE HRD ACCEPT
                            Swal.fire({
                                icon: 'error',
                                title: `Uploading to XRS failed. Kindly reupload data.`,
                                text: socket.data.result,
                            }).then(async () => {
                                await removeHrdAccept(socket.data.latest);
                                await this.getView();
                                this.overlay = false;
                            })
                        }
                }
                else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'getRestriction' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/viewtable'){
                    // this.testlang = socket.data.outputAuth
                    // console.log(socket,'asasasa')
                    if(socket.data.outputAuth == 1 || socket.data.outputAuth == 2 || this.loggedInUser.type == 'Admin' || this.loggedInUser.type == 'HRD Requestor' || this.loggedInUser.type == 'Plan Control') {
                        this.$store.state.authorityResponse = this.loggedInUser.type == 'Admin' ? 2 : socket.data.outputAuth
                        this.$router.push({name : 'main'})
                    }else{
                        // alert(socket.data.errorMessage || '指定したお客様コードの情報が取得出来ません。')
                        Swal.fire({
                            html: '<div style="text-align: center;font-size:26px;font-weight:bold;">' +
                                '指定したお客様コードの情報が取得出来ません。',
                            icon: 'warning',
                            width : 630,
                        }).then(() =>{
                            this.$store.state.customerCodeFromView = null
                            this.$store.state.getXml = null
                            this.$store.state.authorityResponse = null
                            this.$store.commit('SET_EXISTING_REVISIONS', [])
                            this.$store.commit('setCadRequestBasicInformation', {})
                        });
                    }
                }
            }
        // }
    },

    computed: {
        ...mapState([
            'viewMode',
            'rules',
            'REMARKS',
            'customerCodeFromView',
            'loggedInUser',
            'columnRestriction',
            'cadRequestBasicInformation',
            'editCadRequestRevisionContent',
            'existingRevisions',
            'PH6Planners'
        ]),

        pages(){
            let a = this.searchInViewTable.length,
                b = 100;
                return Math.ceil(a/b);
        },

        nextViewPage(){
            const start = (this.page - 1) * 100,
            end = start + 100;
            let c = this.searchInViewTable.slice(start,end);
            return c;
        },

        searchInViewTable(){
            return this.viewtable.filter((data) => {
                let searchData = new RegExp(this.constructionCode.toUpperCase(), "g");
                let concatenatedValue = data.customer_code + '-' + data.revision_number;
                    return concatenatedValue.toUpperCase().match(searchData) || JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
            });
            // OLD FILTERING OF DATA NOT INCLUDED THE REVISION NUMBER W OR W/o (-)
            // return this.viewtable.filter((data) => {
            //     let searchData = new RegExp(this.search.toUpperCase(), "g");
            //         return JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
            // });
        },

        xmlBundlePages(){
            let a = this.searchInXml.length,
                b = 100;
                return Math.ceil(a/b);
        },

        nextXmlBundlePage(){
            const start = (this.xmlPage - 1) * 100,
            end = start + 100;
            let c = this.searchInXml.slice(start,end);
            return c;
        },


        searchInXml(){
            return this.XmlData.filter((data) => {
                let searchData = new RegExp(this.searchXml.toUpperCase(), "g");
                let concatenatedValue = data.code_number + '-' + data.plan_number;
                    return concatenatedValue.toUpperCase().match(searchData) || JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
            });
            // OLD FILTERING OF DATA NOT INCLUDED THE REVISION NUMBER W OR W/o (-)
            // return this.XmlData.filter((data) => {
            //     let searchData = new RegExp(this.searchXml.toUpperCase(), "g");
            //         return JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
            // });
        },
    },

    methods:{
        ...mapActions([
            '_getRemarks',
            '_getPlanner'
            // 'getUpdatedVersion',
        ]),

        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async getSytemMaintenanceDatetime(){
            await axios({
                method: 'get',
                url: 'api/system_maintenance_datetime'
            }).then(({data}) => {
                this.isUnderMaintenance = data[0].is_undermaintenance;
                this.japanDate = data[0].japan_date;
                this.japanTime = data[0].japan_time;
                this.philippineTime = data[0].ph_time;
            })
        },

        // testsesesese(){
        //     let sekisanCheckList = {
        //         customerCode: '0000000-0040',
        //         sendNo: '22',
        //         iraiKbn: '1',
        //         checkJisshiKaisu: '0',
        //         zumenShiyoshoNo: 'test',
        //         denkiZumenNo: null,
        //         mitsumoriNo: null,
        //         houseTypeName: 'GRAND SMART',
        //         tankaKijunDate: null,
        //         hrdSendKaisu: '0',
        //         checkIraiDate: '2024/03/18 20:53:00.000',
        //         checkYoteiDate: '2024/03/26 22:00:00.000',
        //         checkCompDate: null,
        //         soiKbn: null,
        //         sekisanCheckResultList: null
        //     }
        //     axios.post('http://boss.hamamatsu.ichijo.jp/bossservice2/rest/sekisan/sekisanCheck/result', sekisanCheckList)
        //         .then(() => {
        //             console.log('success')
        //         })
        //         .catch(error => {
        //             console.error(error);
        //         });
        // },

        toggleBossListDialog(value){
            // console.log(value,'value')
            if(value){
                this.dialogBossList = true;
                this.overlay = false;
            } else {
                this.dialogBossList= false;
            }
        },

        // NOTE : SAVE TO HRDAPPS49(xml_bundle_schedule_v2)
        async saveToLocal(){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        saveData: this.sendToLocal,
                        uniqId: this.loggedInUser.uniqId,
                        latest: this.editRecord,
                        register_date : this.$store.state.registerDate,
                    },
                    functionType: 'save_to_local'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
        },

        // MANUAL ADD TO FILE ENTRY IF DID NOT REGISTER
        addToBoss(){
            //let url = `${server}${hrdBossMailApi}${register}`;
            if(this.hrdIdAdd) {
                let url = `http://i-manager:9999/api/register`;

                let formData = {}
                formData.customerCode = this.bossCustomerCode;
                formData.plannerCode = this.bossPlannerCode;
                formData.planNumber = this.bossPlanNumber
                formData.hrdId = this.hrdIdAdd,
                formData.planType = this.bossPlanType,
                formData.receivedDay = this.bossReceivedDay,
                formData.finishPlanDay = this.bossFinishPlanDay,
                formData.finishedDay = '',
                formData.remarks = ''

                axios.post(url, formData, {headers:{'auth':'1797c0ea868b691560cb0c54f4024dbd'}})
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: `Successfully uploaded to boss`,
                    }).then(() => {
                    })
                    console.log('success')
                    // console.log(res.data)
                })
                .catch(err => {
                    console.log(err.message)
                })
            }
        },
        deleteToBoss(){
            if(this.hrdIdDel){
                axios({
                    method: "POST",
                    url: "api/getDataByHrdId",
                    data: {
                        hrd_id : this.hrdIdDel
                    }
                }).then(async ({data}) => {
                    if(data){
                        await this.triggerSocketBossSending(data, 'DELETE');
                        await axios({
                            method: "POST",
                            url: "api/deleteToXmlByHrdId",
                            data: {
                                xml : data
                            }
                        }).then(({data}) => {
                            console.log(data)
                        })
                    }
                })
            }
        },
        deleteManual(){
            let formData = {
                    'customerCode': this.trashCustomerCode,
                    'hrdId': this.hrdIdTrash,
                    'planType': this.trashPlanType,
                }

                //let url = `${server}${hrdBossMailApi}${deletedata}`;
                let url = `http://i-manager:9999/api/deletedata`;

                axios.post(url, formData, {headers:{'auth':'1797c0ea868b691560cb0c54f4024dbd'}})
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: `Successfully delete to boss`,
                    }).then(() => {
                    })
                })
                .catch(err => {
                    console.log(err.message)
                    //alert(err.message)
                })
        },
            // NOTE : SEND THE DATA TO BACKET FOR GATHERING OF OTHER DETAILS FOR BOSS CODES
        async sendToBackend(data){
            console.log(data, 'send to back')
            let tempArr = data.latestData
            this.$store.state.bundle_sched = data.isHoliday;
            this.$store.state.cadRequestBasicInformation = this.basicInfo
            data.whole_date = data.created_at;
            let bossCodes = await getAllBossCode(
                // this.$store.state.revisionSelection,
                null,
                this.basicInfo,
                tempArr,
                null,
                this.$store.state.ph6User
            );
            console.log(bossCodes, 'send to back', )
            const json = await json_remarks(
                this.basicInfo,
                tempArr,
                data,
                bossCodes
            );
            const created_date = this.formatDateTime(tempArr.created_at);
            let zumenMulti = await getZumenTypeMultiple(bossCodes);
            if(tempArr.hrd_accept == 1){
                bossCodes = bossCodes.filter((r) => {
                    if(r.boss_code != '357'){
                        return r
                    }
                    return false;
                })
            }
            try {
                axios({
                    method: "POST",
                    url: "api/getBossData",
                    data: {
                        boss : bossCodes,
                        json : json,
                        zumen : zumenMulti,
                        createdDate : created_date,
                        latestData : data.latestData,
                        basic : this.basicInfo,
                        schedule: data.outputData,
                        isHoliday: data.isHoliday,
                        user: this.loggedInUser
                    }
                }).then(async ({data}) => {
                    // console.log(tempArr,'....')
                    if(data.mergedData){
                        if(!this.accept){
                            this.$store.state.forRegistration = data.mergedData.map((res) => {
                                const tempParts = [];

                                if (res.plan_type_name) {
                                    tempParts.push(res.plan_type_name);
                                }

                                if (res.boss_code) {
                                    tempParts.push(res.boss_code);
                                }
                                res.temp = tempParts.length > 0 ? tempParts.join(' (') + ')' : '';
                                res.due_day = res.due_day ? moment(res.due_day).format('YYYY-MM-DD HH:mm') : null;
                                res.checkBox = true;
                                return res;
                                
                            })
                            this.toggleBossListDialog(true);
                            this.$store.state.forAlias = tempArr.alias;
                        }else{
                            this.$store.state.forRegistration = data.mergedData.filter((res) => {
                                if(res.boss_code == '357'){
                                    const tempParts = [];

                                    if (res.plan_type_name) {
                                        tempParts.push(res.plan_type_name);
                                    }

                                    if (res.boss_code) {
                                        tempParts.push(res.boss_code);
                                    }

                                    res.temp = tempParts.length > 0 ? tempParts.join(' (') + ')' : '';
                                    res.due_day = res.due_day ? moment(res.due_day).format('YYYY-MM-DD HH:mm') : null;
                                    res.checkBox = true;
                                    return res;
                                }
                                return false;
                            })
                            this.confirmBoss(this.$store.state.forRegistration);

                        }

                    }
                })
            } catch (error) {
                alert(error)
            }
        },

        async confirmBoss(value){ 
            if(value){
                this.sendToLocal = null;
                this.loader = true
                // ! SAVE NEW DATA
                    this.sendToLocal = await saveToXML(
                        value, 
                        false, 
                        this.editRecord, 
                        this.basicInfo,
                        this.plannerDetails,
                        this.salesmanDetails,
                        this.houseTypeFromSocket,
                        this.dataFromCi,
                        this.powerId,
                        this.loggedInUser,
                        this.$store.state.registerDate,
                    );
                    await this.getView();
                    if(this.sendToLocal) await this.hrdAcceptAtt()
                    console.log(this.sendToLocal, 'saved')

            }
        },
        openNotSavedRemarksDialog(item){
            this.notSavedRemarksDialog = true;
            this.remarksNotSavedData = item;
        },

        // GET DETAILS OF XML THAT ARE NOT SAVED TO HRDAPPS49
        openXmlData(item){
            this.notSavedDialog = true;
            axios({
                method: "POST",
                url: 'api/getXmlNotSaved',
                data: item
            }).then(({data}) => {
                this.xmlDataToSave = data.map((r) => {
                                            r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
                                            r.remarks = JSON.parse(r.remarks);
                                            return r;
                                        });

                                        console.log(this.xmlDataToSave)
            })
        },

        // SORTING FOR CREATED DATE AND HRD ACCEPTED DATE IN PLANNER VIEW TABLE
        sortBy(){
            let sortCreated = this.viewtable.slice();
            sortCreated.sort((a,b) => {
                const sortA = new Date(a.created_at);
                const sortB = new Date(b.created_at);

                if (typeof sortA === 'string') {
                // If the column value is a string, perform case-insensitive comparison
                // localeCompare -> returns a number indicating whether this string comes before, or after, or is the same as the given string in sort order
                    return this.sortOrder === 'asc' ? sortA.localeCompare(sortB) : sortB.localeCompare(sortA);
                } else {
                // Otherwise, assume it's a number or date and perform a regular comparison
                return this.sortOrder === 'asc' ? sortB - sortA : sortA - sortB;
                }
                // return sortB - sortA;
            });
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            this.viewtable = sortCreated;
            // console.log(sortCreated,'sortCreated')
        },

        plannerHrdAcceptSortBy(){
            let plannerHrdAcceptDate = this.viewtable.slice();
            plannerHrdAcceptDate.sort((a,b) => {
                const plannerHrdA = new Date(a.hrd_accepted_at);
                const plannerHrdB = new Date(b.hrd_accepted_at);

                if(typeof plannerHrdA == 'string'){
                    return this.hrdAcceptSortOrder === 'asc' ? plannerHrdA.localeCompare(plannerHrdB) : plannerHrdB.localeCompare(plannerHrdA);
                } else {
                    return this.hrdAcceptSortOrder === 'asc' ? plannerHrdB - plannerHrdA : plannerHrdA - plannerHrdB;
                }
            });
            this.hrdAcceptSortOrder = this.hrdAcceptSortOrder === 'asc' ? 'desc' : 'asc';
            this.viewtable = plannerHrdAcceptDate;
        },
        //END

        // SORTING CREATED DATE,HRD ACCEPT DATE, CREATED DATE/TIME IN HRD AND PLANNER VIEW TABLE
        hrdCreatedSortBy(){
            // ---------- O L D ----------
            // let hrdCreatedSort = this.viewtable.slice();
            // // sorting of created_at, A for ascending and B for descending
            // hrdCreatedSort.sort((a,b) => {
            //     const hrdCreatedA = new Date(a.created_at);
            //     const hrdCreatedB = new Date(b.created_at);

            //     if (typeof hrdCreatedA == 'string') {
            //         return this.hrdCreatedSortOrder === 'asc' ? hrdCreatedA.localeCompare(hrdCreatedB) : hrdCreatedB.localeCompare(hrdCreatedA);
            //     } else {
            //         return this.hrdCreatedSortOrder === 'asc' ? hrdCreatedB - hrdCreatedA : hrdCreatedA - hrdCreatedB;
            //     }
            // });
            // this.hrdCreatedSortOrder = this.hrdCreatedSortOrder === 'asc' ? 'desc' : 'asc';
            // // dito mag rereflect yung sorting
            // this.viewtable = hrdCreatedSort;

            // ---------- N E W ----------
            this.createdSort = this.createdSort == null || this.createdSort == 'ASC' ? 'DESC' : 'ASC'
            this.hrdAcceptSort = null
            this.currentPage = 1
            this.getView()
            console.log(this.createdSort)
        },

        hrdAcceptedDateSortBy(){
            // ---------- O L D ----------
            // let hrdAcceptDate = this.viewtable.slice();
            // // sorting of hrd_accepted_at, A for ascending and B for descending
            // hrdAcceptDate.sort((a,b) => {
            //     const hrdAcceptA = new Date(a.hrd_accepted_at);
            //     const hrdAcceptB = new Date(b.hrd_accepted_at);

            //     if (typeof hrdAcceptA == 'string'){
            //         return this.hrdAcceptDateSortOrder === 'asc' ? hrdAcceptA.localeCompare(hrdAcceptB) : hrdAcceptB.localeCompare(hrdAcceptA);
            //     } else {
            //         return this.hrdAcceptDateSortOrder === 'asc' ? hrdAcceptB - hrdAcceptA : hrdAcceptA - hrdAcceptB;
            //     }
            // });

            // this.hrdAcceptDateSortOrder = this.hrdAcceptDateSortOrder === 'asc' ? 'desc' : 'asc';
            // // dito mag rereflect yung sorting
            // this.viewtable = hrdAcceptDate;

            // ---------- N E W ----------
            this.hrdAcceptSort = this.hrdAcceptSort == null || this.hrdAcceptSort == 'ASC' ? 'DESC' : 'ASC'
            this.createdSort = null
            this.currentPage = 1
            this.getView()
            console.log(this.hrdAcceptSort)
        },
        //END


        getPreviousWeek(selection){
            this.disableForward = false
            let lastDay = null

            if(selection == 'prev'){
                lastDay = new Date(this.sevenDaysHeader[this.sevenDaysHeader.length - 1].date);
                lastDay.setDate(lastDay.getDate() - 1);
            }else if(selection == 'for'){
                lastDay = new Date(this.sevenDaysHeader[0].date);
                lastDay.setDate(lastDay.getDate() + 7);
            }
            // Format the result as a string in 'YYYY-MM-DD' format
            this.dateToday = moment(lastDay.toISOString().split('T')[0]);
            this.getForLoopSched();
            if(moment(lastDay).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) this.disableForward = true


        },

        // NOTE : GET 1 WEEK BACKWARDS
        getForLoopSched(){
            this.overlay = true; 
            // this.dateToday = moment().format('YYYY-MM-DD');
            // Get the current date
            // Create an array to store the dates
            let temp = [];
            let header = {};
            const totalCountPerDay = {};

            // Loop to get the dates for all 7 days before today
                for (let i = 0; i < 7; i++) {
                    header = {}
                    let currentDate = this.dateToday.clone().subtract(i, 'days');
                    header.covered = 'Bracket Covered';
                    header.boss = 'BOSS DUE DAY';
                    header.date = currentDate.format('YYYY-MM-DD');
                    header.day = currentDate.format('ddd');
                    if(header.day == 'Mon'){
                        header.jap = '月';
                        header.due_day_am = '水 (WED)';
                        header.due_day_pm = '水 (WED)';
                        header.bracket_am = 'Sun 3-2 ～ Mon 1';
                        header.bracket_pm = 'Mon 2-1 ～ 3-1';
                        header.bracket_time_am = 'Sun 18:01 - Mon 11:00';
                        header.bracket_time_pm = 'Mon 11:01 - 18:00';
                    }else if(header.day == 'Tue'){
                        header.jap = '火';
                        header.due_day_am = '木  (THU)';
                        header.due_day_pm = '木  (THU)';
                        header.bracket_am = 'Tue 3-2 ～ Wed 1';
                        header.bracket_pm = 'Tue 2-1 ～ 3-1';
                        header.bracket_time_am = 'Mon 18:01 - Tue 11:00';
                        header.bracket_time_pm = 'Tue 11:01 - 18:00';
                    } else if(header.day == 'Wed'){
                        header.jap = '水';
                        header.due_day_am = '木  (THU)';
                        header.due_day_pm = '金 (FRI)';
                        header.bracket_am = 'Tue 3-2 ～ Wed 1';
                        header.bracket_pm = 'Wed 2-1 ～ 3-1';
                        header.bracket_time_am = 'Tue 18:01 - Wed 11:00';
                        header.bracket_time_pm = 'Wed 11:01 - 18:00';
                    } else if(header.day == 'Thu'){
                        header.jap = '木';
                        header.due_day_am = '金 (FRI)';
                        header.due_day_pm = '土 (SAT)';
                        header.bracket_am = 'Wed 3-2 ～ Thu 1';
                        header.bracket_pm = 'Thu 2-1 ～ 3-1';
                        header.bracket_time_am = 'Wed 18:01 - Thu 11:00';
                        header.bracket_time_pm = 'Thu 11:01 - 18:00';
                    } else if(header.day == 'Fri'){
                        header.jap = '金';
                        header.due_day_am = '土 (SAT)';
                        header.due_day_pm = '月 (MON)';
                        header.bracket_am = 'Thu 3-2 ～ Fri 1';
                        header.bracket_pm = 'Fri 2-1 ～ 3-1';
                        header.bracket_time_am = 'Thu 18:01 - Fri 11:00';
                        header.bracket_time_pm = 'Fri 11:01 - 18:00';
                    } else if(header.day == 'Sat'){
                        header.jap = '土';
                        header.due_day_am = '月 (MON)';
                        header.due_day_pm = '火 (TUE)';
                        header.bracket_am = 'Fri 3-2 ～ Sat 1';
                        header.bracket_pm = 'Sat 2-1 ～ 3-1';
                        header.bracket_time_am = 'Fri 18:01 - Sat 11:00';
                        header.bracket_time_pm = 'Sat 11:01 - 18:00';
                    } else if(header.day == 'Sun'){
                        header.jap = '日';
                        header.due_day_am = '火 (TUE)';
                        header.due_day_pm = '火 (TUE)';
                        header.bracket_am = 'Sat 3-2 ～ Sun 1';
                        header.bracket_pm = 'Sun 2-1 ～ 3-1';
                        header.bracket_time_am = 'Sat 18:01 - Sun 11:00';
                        header.bracket_time_pm = 'Sun 11:01 - 18:00';
                    } 
                    temp.push(header);
                }
                this.sevenDaysHeader = temp.filter((r) => {
                    r.shortCut = moment(r.date).format('MM/DD');
                    return r;
                })

                axios({
                    method: "POST",
                    url: "api/getAllRegisteredData",
                    data: {
                        dates : temp
                    }
                }).then(({data}) => {
                    if(data){
                        // Assuming this.sevenDaysHeader is initialized before running this logic
                        let totalCountPerDayAM = {};
                        let totalCountPerDayPM = {};
                        let without003TotalCountPerDayAM = {};
                        let without003TotalCountPerDayPM = {};
                        let expressTotalCountPerDayAM = {};
                        let expressTotalCountPerDayPM = {};
                        let expressWithout003TotalCountPerDayAM = {};
                        let expressWithout003TotalCountPerDayPM = {};

                        this.processResultData(data.cadPlans, totalCountPerDayAM, totalCountPerDayPM);
                        this.processResultData(data.notCadPlans, without003TotalCountPerDayAM, without003TotalCountPerDayPM);
                        this.processResultData(data.cadExpress, expressTotalCountPerDayAM, expressTotalCountPerDayPM);
                        this.processResultData(data.notCadExpress, expressWithout003TotalCountPerDayAM, expressWithout003TotalCountPerDayPM);
      
                        this.sevenDaysHeader = this.sevenDaysHeader.map((r) => {
                            // CAD PLANS
                            r.total_count_am_003 = totalCountPerDayAM[r.day.toUpperCase()] || 0;
                            r.total_count_pm_003 = totalCountPerDayPM[r.day.toUpperCase()] || 0;
                            // NOT CAD PLANS
                            r.total_count_am = without003TotalCountPerDayAM[r.day.toUpperCase()] || 0;
                            r.total_count_pm = without003TotalCountPerDayPM[r.day.toUpperCase()] || 0;
                            // CAD EXPRESS
                            r.express_count_am_003 = expressTotalCountPerDayAM[r.day.toUpperCase()] || 0;
                            r.express_count_pm_003 = expressTotalCountPerDayPM[r.day.toUpperCase()] || 0;
                            // NOT CAD EXPRESS
                            r.express_count_am = expressWithout003TotalCountPerDayAM[r.day.toUpperCase()] || 0;
                            r.express_count_pm = expressWithout003TotalCountPerDayPM[r.day.toUpperCase()] || 0;
                            return r;
                        });
                    }
                    this.overlay = false;
                })
        },

        processResultData(data, totalCountPerDayAM, totalCountPerDayPM) {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    // Extract the day and time from the key (e.g., "FRI_am" => { day: "FRI", time: "am" })
                    const [day, time] = key.split('_');

                    // Create a new object for the day if it doesn't exist
                    if (!totalCountPerDayAM[day]) {
                        totalCountPerDayAM[day] = 0;
                    }
                    if (!totalCountPerDayPM[day]) {
                        totalCountPerDayPM[day] = 0;
                    }

                    // Add the total count to the corresponding result based on time
                    if (time === 'am') {
                        totalCountPerDayAM[day] += data[key].total_count;
                    } else if (time === 'pm') {
                        totalCountPerDayPM[day] += data[key].total_count;
                    }
                }
            }
        },

        logTab(tabName) {
            this.getTabName = tabName;
            // console.log('Clicked tab:', this.getTabName);
        },

        // ----------- O L D -----------
        // filterByTab(){
        //     // console.log(this.defaultTab,'defaultTab')
        //     // if(this.defaultTab == 0){
        //     //     console.log('hrd')
        //     // }else if(this.defaultTab == 1){
        //     //     console.log('planner')
        //     // }else 
        //     if(this.getTabName == 'HRD VIEW TABLE' || this.getTabName == 'PLANNER VIEW TABLE'){
        //         this.hrdAcceptSelect = "Not Yet Accepted";
        //         this.getView();
        //     }

        //     if(this.getTabName == 'CAD依頼受付状況') {
        //         this.getForLoopSched();
        //     }

        //     if(this.defaultTab == 2){
        //         this.hrdAcceptSelect = "Accepted";
        //         this.getXmlData();
        //     }else if(this.defaultTab == 4){
        //         this.overlay = true; 
        //         axios({
        //             method: 'POST',
        //             url: 'api/getNotSentToBoss',
        //             data : {
        //                 dateFrom : this.dateFrom,
        //                 dateTo : this.dateTo,
        //             }
        //         }).then(({data}) => {
        //             this.notUploaded = data
        //         })
        //         this.overlay = false; 
        //     }
        // },

        // ----------- N E W -----------
        filterByTab() {
            this.currentPage = 1
            this.totalFrom = 0
            this.totalTo = 0
            this.totalRecord = 0
            this.search = ''
            if (this.getTabName == 'HRD VIEW TABLE' || this.getTabName == 'PLANNER VIEW TABLE') {
                this.viewtable = []
                this.hrdAcceptSelect = "Not Yet Accepted";
                this.getView()
            // } else if (this.defaultTab == 2) {
            } else if (this.getTabName == 'XML BUNDLE SCHEDULE TABLE') {
                this.XmlData = []
                this.hrdAcceptSelect = "All"
                this.filterDateSelection = 'Filter By Date'
                this.getXmlData()
            } else if (this.getTabName == 'CAD依頼受付状況') {
                this.getForLoopSched()
            } else if (this.defaultTab == 4) {
                this.overlay = true;
                axios({
                    method: 'POST',
                    url: 'api/getNotSentToBoss',
                    data : {
                        dateFrom : this.dateFrom,
                        dateTo : this.dateTo,
                    }
                }).then(({data}) => {
                    this.notUploaded = data
                })
                this.overlay = false
            }
        },

        // async ExtractData() {
        //     this.overlay = true;

        //     let date = moment().format('YYYYMMDD')
        //     let filename = `${date}-CRS`

        //     const workbook = new ExcelJS.Workbook();
        //     const worksheet = workbook.addWorksheet('Sheet 1');
        //     // Extract property names from the first record as the header
        //     // const headerRow = Object.keys(this.viewtable[0]);
        //     const cols = [
        //         {   text: "Customer Code",
        //             value: "customer_code"
        //         },
        //         {   text: "Revision",
        //             value: "revision_number"
        //         },
        //         {   text: "Created Date",
        //             value: "created_at"
        //         },
        //         {   text: "Created By",
        //             value: "created_by_code"
        //         },
        //         {   text: "Created By Code",
        //             value: "user_id"
        //         },
        //         {   text: "Gravity",
        //             value: "gravity"
        //         },
        //         {   text: "Request Type",
        //             value: "request_type"
        //         },
        //         {   text: "Express",
        //             value: "express"
        //         },
        //         {   text: "Hrd Accepted By",
        //             value: "hrd_accepted_user_id"
        //             // value: "hrd_accept"
        //         },
        //         {   text: "Hrd Accepted Date",
        //             value: "hrd_accepted_at"
        //         },
        //         {   text: "House Type",
        //             value: "alias"
        //         },
        //         {   text: "House Type Name",
        //             value: "name"
        //         },
        //         {   text: "Remarks",
        //             value: "remarks"
        //         },
        //         {   text: "Fire Protection",
        //             value: "fire_protection"
        //         },
        //         {   text: "Water Tight",
        //             value: "water_tight"
        //         },
        //         {   text: "Heavy Snow",
        //             value: "heavy_snow"
        //         },
        //         {   text: "Rectangle Meter",
        //             value: "rectangle_meter"
        //         },
        //         {   text: "Double Earthquake Resistance",
        //             value: "double_earthquake_resistance"
        //         },
        //         {   text: "High Fireproof OuterWall",
        //             value: "high_fireproof_outer_wall"
        //         },
        //         {   text: "After Kakou Reason",
        //             value: "kakouirai_reason"
        //         },
        //         {   text: "Design Contract",
        //             value: "design_contract"
        //         },
        //         {   text: "Calculation Basis",
        //             value: "calculation_basis"
        //         },
        //         {   text: "Color Layout",
        //             value: "site_layout",
        //         },
        //         // {   text: "",
        //         //     value: "dxf_data_request"},
        //         // {   text: "",
        //         //     value: "color_pers"},
        //         // {   text: "",
        //         //     value: "house_presentation"},
        //         // {   text: "",
        //         //     value: "shio_request"},
        //     ];

        //     const headerRow = cols.map((r) => r.text)
            
        //     // Add the header row to the worksheet
        //     worksheet.addRow(headerRow);

        //     // Iterate through the data and add rows to the worksheet
        //     this.forExtract.forEach(record => {
        //         const dataRow = cols.map(propertyName => {
        //         let propertyValue = record[propertyName.value];

        //         // ? GRAVITY
        //         if(propertyName.value == 'gravity'){
        //             if(propertyValue == 0) propertyValue = 'CADの変更なし (NC)';
        //             else if(propertyValue == 1) propertyValue = '軽微な変更 (S)';
        //             else if(propertyValue == 2) propertyValue = '通常の変更 (M)';
        //             else if(propertyValue == 3) propertyValue = '大きな変更 (L)';
        //         }
        //         if((propertyName.value == 'revision_type')){
        //             if(propertyValue == 8) record['gravity'] = '大きな変更 (L)';
        //             else if(propertyValue == 9) record['gravity'] = '大きな変更 (L)';
        //         }

        //         // ? REVISION TYPE
        //         if((propertyName.value == 'revision_type')){
        //             if(propertyValue == 8) record['gravity'] = '大きな変更 (L)';
        //             else if(propertyValue == 9) record['gravity'] = '大きな変更 (L)';
        //         }

        //         // ? YES NO FOR 1 - 0 DATA
        //         if(propertyName.value == 'express'){
        //             propertyValue = propertyValue == '1' ? 'YES' : 'NO'
        //         }

        //         // ? ARI NASHI FOR 1 - 0 DATA
        //         if( propertyName.value == 'fire_protection' || 
        //             propertyName.value == 'heavy_snow' ||
        //             propertyName.value == 'double_earthquake_resistance' ||
        //             propertyName.value == 'high_fireproof_outer_wall' || 
        //             propertyName.value == 'design_contract' ||
        //             propertyName.value == 'calculation_basis'
        //         ){
        //             propertyValue = propertyValue == '1' ? 'あり' : 'なし'
        //         }

        //         // ? SITE LAYOUT
        //         if (propertyName.value == 'site_layout') {
        //             if(record['site_layout'] == '新規データN' && record['site_layout_option'] == 'option1') {
        //                 propertyValue = `${record.site_layout || ''}\nBOSS送信済み\n屋外配管経路図\u0020${record.site_diagram || ''}`;
        //             }else if(record['site_layout'] == '新規データN' && record['site_diagram'] != null){
        //                 propertyValue = `${record.site_layout || ''}\n屋外配管経路図\u0020${record.site_diagram || ''}`
        //             }else if(record['site_layout'] == '新規データN') {
        //                 propertyValue = record.site_layout
        //             }else if(record['site_layout'] == '前回ベースP' && record['new_site_diagram'] != null){
        //                 propertyValue = `${record.site_layout || ''}\n屋外配管経路図\u0020${record.new_site_diagram || ''}`
        //             }else if(record['site_layout'] != '前回ベースP' || record['site_layout'] != '新規データN'){
        //                 propertyValue = record.site_layout
        //             }
        //         }
                
                
        //         // Check if the property value is an object, and if so, return an empty string
        //         return typeof propertyValue === 'object' ? '' : propertyValue;
        //         });
        //         const row = worksheet.addRow(dataRow);
        //         // row.height = 25;
        //     });
        //     // Create a buffer containing the Excel file
        //     const buffer = await workbook.xlsx.writeBuffer();

        //     // Create a Blob and URL for downloading
        //     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //     const url = window.URL.createObjectURL(blob);

        //     // Create a download link
        //     const a = document.createElement('a');
        //     a.href = url;
        //     a.download = `${filename}.xlsx`;

        //     // Trigger the download
        //     a.click();

        //     // Clean up
        //     window.URL.revokeObjectURL(url);
        //     this.overlay = false;

        // },

        async ExtractData() {
            this.overlay = true

            let forExtract = []
            try {
                // LOOP AXIOS - NOT GOOD
                // for (let i = 1; i <= this.metaData.last_page; i++) {
                //     const res = await axios({
                //         method: 'POST',
                //         url: `api/view-table?page=${i}`,
                //         data: {
                //             dateFilter: this.filterDateSelection,
                //             hrd_accept: this.hrdAcceptSelect,
                //             express: this.expressSelect,
                //             dateFrom: this.dateFrom,
                //             dateTo: this.dateTo,
                //             loggedInUser : this.loggedInUser,
                //             search: this.constructionCode,
                //         }
                //     });
                //     // Merging the data
                //     forExtract = [...forExtract, ...res.data.data]
                // }

                await axios({
                    method : 'post',
                    url : 'api/extract',
                    data: {
                        dateFilter: this.filterDateSelection,
                        hrd_accept: this.hrdAcceptSelect,
                        express: this.expressSelect,
                        dateFrom: this.dateFrom,
                        dateTo: this.dateTo,
                        loggedInUser : this.loggedInUser,
                        search: this.constructionCode,
                    }
                }).then((res) => {
                    forExtract = res.data.map((a) => {
                        const d = new Date(a.created_at);
                        return {
                            ...a,
                            // created_at : `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')} ${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}:${String(d.getUTCSeconds()).padStart(2, '0')}`
                            created_at : moment(d).format('YYYY-MM-DD HH:mm:ss')
                        }
                    });
                })

                let date = moment().format('YYYYMMDD');
                let filename = `${date}-CRS`;

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet 1');

                const cols = [
                    { text: "Customer Code", value: "customer_code" },
                    { text: "Revision", value: "revision_number" },
                    { text: "Created Date", value: "created_at" },
                    { text: "Created By", value: "created_by_code" },
                    { text: "Created By Code", value: "user_id" },
                    { text: "Gravity", value: "gravity" },
                    { text: "Request Type", value: "request_type" },
                    { text: "Express", value: "express" },
                    { text: "Hrd Accepted By", value: "hrd_accepted_user_id" },
                    { text: "Hrd Accepted Date", value: "hrd_accepted_at" },
                    { text: "House Type", value: "alias" },
                    { text: "House Type Name", value: "name" },
                    { text: "Remarks", value: "remarks" },
                    { text: "Fire Protection", value: "fire_protection" },
                    { text: "Water Tight", value: "water_tight" },
                    { text: "Heavy Snow", value: "heavy_snow" },
                    { text: "Rectangle Meter", value: "rectangle_meter" },
                    { text: "Double Earthquake Resistance", value: "double_earthquake_resistance" },
                    { text: "High Fireproof OuterWall", value: "high_fireproof_outer_wall" },
                    { text: "After Kakou Reason", value: "kakouirai_reason" },
                    { text: "Design Contract", value: "design_contract" },
                    { text: "Calculation Basis", value: "calculation_basis" },
                    { text: "Color Layout", value: "site_layout" },
                ];

                const headerRow = cols.map((r) => r.text);
                worksheet.addRow(headerRow);

                // Iterate through the data and add rows to the worksheet
                forExtract.forEach(record => {
                    const dataRow = cols.map(propertyName => {
                        let propertyValue = record[propertyName.value];

                        // Format created_at
                        // if (propertyName.value === 'created_at') {
                        //     propertyValue = moment(propertyValue).format('YYYY-MM-DD HH:mm:ss');
                        // }

                        // GRAVITY
                        if(propertyName.value == 'gravity'){
                            if(propertyValue == 0) propertyValue = 'CADの変更なし (NC)';
                            else if(propertyValue == 1) propertyValue = '軽微な変更 (S)';
                            else if(propertyValue == 2) propertyValue = '通常の変更 (M)';
                            else if(propertyValue == 3) propertyValue = '大きな変更 (L)';
                        }

                        // ? REVISION TYPE
                        if((propertyName.value == 'revision_type')){
                            if(propertyValue == 8) record['gravity'] = '大きな変更 (L)';
                            else if(propertyValue == 9) record['gravity'] = '大きな変更 (L)';
                        }

                        // ? YES NO FOR 1 - 0 DATA
                        if(propertyName.value == 'express'){
                            propertyValue = propertyValue == '1' ? 'YES' : 'NO'
                        }

                        // ? ARI NASHI FOR 1 - 0 DATA
                        if( propertyName.value == 'fire_protection' || 
                            propertyName.value == 'heavy_snow' ||
                            propertyName.value == 'double_earthquake_resistance' ||
                            propertyName.value == 'high_fireproof_outer_wall' || 
                            propertyName.value == 'design_contract' ||
                            propertyName.value == 'calculation_basis'
                        ){
                            propertyValue = propertyValue == '1' ? 'あり' : 'なし'
                        }

                        // ? SITE LAYOUT
                        if (propertyName.value == 'site_layout') {
                            if(record['site_layout'] == '新規データN' && record['site_layout_option'] == 'option1') {
                                propertyValue = `${record.site_layout || ''}\nBOSS送信済み\n屋外配管経路図\u0020${record.site_diagram || ''}`;
                            }else if(record['site_layout'] == '新規データN' && record['site_diagram'] != null){
                                propertyValue = `${record.site_layout || ''}\n屋外配管経路図\u0020${record.site_diagram || ''}`
                            }else if(record['site_layout'] == '新規データN') {
                                propertyValue = record.site_layout
                            }else if(record['site_layout'] == '前回ベースP' && record['new_site_diagram'] != null){
                                propertyValue = `${record.site_layout || ''}\n屋外配管経路図\u0020${record.new_site_diagram || ''}`
                            }else if(record['site_layout'] != '前回ベースP' || record['site_layout'] != '新規データN'){
                                propertyValue = record.site_layout
                            }
                        }

                        return typeof propertyValue === 'object' ? '' : propertyValue;
                    });

                    worksheet.addRow(dataRow);
                });

                // Create a buffer containing the Excel file
                const buffer = await workbook.xlsx.writeBuffer();

                // Create a Blob and URL for downloading
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);

                // Create a download link
                const a = document.createElement('a');
                a.href = url;
                a.download = `${filename}.xlsx`;

                // Trigger the download
                a.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                this.overlay = false;
            } catch (error) {
                console.error('Error extracting data:', error);
                this.overlay = false;
            }
        },
        
        openBossSchedDialog(){
            // console.log('test')
            this.schedule = [];
            this.bossSchedDialog = true;
            if(this.XmlData){
                this.XmlData.filter((res) => {
                    if(res.cad_request_id == this.editRecord.id){
                        if(this.loggedInUser.is_admin || this.loggedInUser.plan_control || this.loggedInUser.is_hrd_viewer || this.loggedInUser.is_hrd_requestor){
                            this.schedule.push({
                                plan_type: `${res.plan_type_name}(${res.boss_code})`,
                                due: res.due_day ? moment(res.due_day).format('YYYY/MM/DD HH:mm') : null,
                            })
                        }else if(this.loggedInUser.is_gc_user || this.loggedInUser.is_ichijo_user || this.loggedInUser.is_rulebook_user || this.loggedInUser.plan_control || this.loggedInUser.is_admin || this.loggedInUser.is_special_account || this.loggedInUser.japan_admin){
                            if(res.display == 1){
                                this.schedule.push({
                                    plan_type: `${res.plan_type_name}(${res.boss_code})`,
                                    due: res.due_day ? moment(res.due_day).format('YYYY/MM/DD HH:mm') : null,
                                })
                            }
                        }

                    }
                })
            }
        },

        // ---------- O L D ----------
        // getXmlData(){
        //     this.overlay = true;
        //         axios({
        //             method: "POST",
        //             url: "api/xml_bundle",
        //             data: {
        //                 dateFrom: this.dateFrom,
        //                 dateTo: this.dateTo,
        //                 isExpress: this.expressSelect,
        //                 search : this.searchXml,
        //                 // skip: this.xmlSkip,
        //                 // limit: this.xmlLimit,
        //             }
        //         }).then(({data}) => {
        //             if(data){
        //                 this.XmlData = data.map((r) => {
        //                     r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
        //                     return r;
        //                 })
        //                 // this.totalItems = data.total;
        //             }
        //             this.overlay = false;
        //         })
        // },

        // ---------- N E W ----------
        getXmlData(){
            this.ConvertPlanNumber(this.search)
            this.overlay = true
            axios({
                method: "POST",
                url: `api/xml_bundle?page=${this.currentPage}`,
                data: {
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                    isExpress: this.expressSelect,
                    search : this.constructionCode == '-' ? '' : this.constructionCode,
                }
            }).then((res) => {
                // console.log(res.data)
                this.metaData = res.data
                this.totalRecord = res.data.total
                this.totalFrom = res.data.from
                this.totalTo = res.data.to
                this.next_page_url = this.metaData.next_page_url
                this.lastPage = this.metaData.last_page
                this.XmlData = res.data.data.map((r) => {
                    r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
                    return r;
                })
                this.overlay = false;
            })
        },

        searchXmlBundle(){
            this.XmlData = []
            this.overlay = true;
                axios({
                    method: "POST",
                    url: "api/xml_bundle",
                    data: {
                        dateFrom: this.dateFrom,
                        dateTo: this.dateTo,
                        isExpress: this.expressSelect,
                        search : this.searchXml,
                    }
                }).then(({data}) => {
                    if(data){
                        this.XmlData = data.map((r) => {
                            r.created_at = moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')
                            return r;
                        })
                    }
                    this.overlay = false;
                })
        },

        getAllXmlData(){
            if(this.searchXml.length == 12 || this.searchXml.length >= 16 && this.searchXml.length <= 18) {
                // this.searchXmlBundle();
                this.getXmlData();
                this.xmlPage = 1;
            } else if(this.searchXml == '') {
                this.getXmlData();
                this.xmlPage = 1;
            }
        },

        openRemarksDialog(data){
            this.remarksDialog = true;
            this.remarksData = JSON.parse(data)
        },

        // refreshView(){
        //     window.location.href='/home';
        // },
    
    // ****************************************************************** //
    //                  UPDATING on XML table for SRS                     //
    // ****************************************************************** //

    // NOTE : if plan is edited
        async updateXMLTable(latestData){
            let dataToUpdate = latestData;
                // CONDITION FOR FINAL PLAN
                    if(latestData.final_plan == '1'){
                        dataToUpdate.final_plan = '003'
                    }else if(latestData.final_plan == '2'){
                        dataToUpdate.final_plan = '001'
                    }else if(latestData.final_plan == '3'){
                        dataToUpdate.final_plan = '002'
                    }else{
                        dataToUpdate.final_plan = null
                    }
                    
                // CONDITION FOR REVISION/REQUEST TYPE
                    if(latestData.revision_type == '1'){
                        dataToUpdate.revision_type = '新規(A)';
                    }else{
                        if(latestData.revision_type == '5'){
                            if(latestData.gravity_type == '5Z'){
                                dataToUpdate.revision_type = '新規(A)';
                            }
                        }else if(latestData.revision_type == '7'){
                            if(latestData.gravity_type == '5Cad'){
                                dataToUpdate.revision_type = '新規(A)';
                            }
                        }else{
                            // if(latestData.kakouirai_reason == 1 || latestData.kakouirai_reason == 2){
                            // if(latestData.kakouirai_reason == 1){
                            //         dataToUpdate.revision_type = '追変(TH)';
                            // } else{
                            // // dataToUpdate.revision_type = '変更(C)';
                            // if(latestData.revision_type == '5'){
                            //     if(latestData.gravity_type == '5Z'){
                            //         dataToUpdate.revision_type = '新規(A)';
                            //     } else {
                            //         dataToUpdate.revision_type = '変更(C)';
                            //     }
                            // }
                        // }
                        if(latestData.kakouirai_reason == 1 ){
                            dataToUpdate.revision_type = '追変(TH)';
                        } else if(latestData.kakouirai_reason == 2 || latestData.kakouirai_reason == 3  || latestData.kakouirai_reason == 4 || latestData.kakouirai_reason == 5 ){
                            if(latestData.revision_type == '5'){
                                if(latestData.gravity_type == '5Z'){
                                    dataToUpdate.revision_type = '新規(A)';
                                } else {
                                    dataToUpdate.revision_type = '変更(C)';
                                }
                            }
                        } else{
                            dataToUpdate.revision_type = '変更(C)';
                        }

                        }
                    }
                                        
                // CONDITION FOR PLAN STATUS
                    if(latestData.basic_info){
                        if(latestData.basic_info.expected_house_raising_date){
                            dataToUpdate.plan_status = 'Already Kakouirai';
                        }else{
                            dataToUpdate.plan_status = 'Before Kakouirai'
                        }
                    }

                dataToUpdate.hrd_accepted_at =  moment(latestData.hrd_accepted_at).format('YYYY-MM-DD HH:mm:ss')
                dataToUpdate.updated_at =  moment(latestData.updated_at).format('YYYY-MM-DD HH:mm:ss')
                dataToUpdate.deleted_at = latestData.deleted_at ? moment(latestData.deleted_at).format('YYYY-MM-DD HH:mm:ss') : null;
                // console.log(dataToUpdate, 'data')
                let sendToBossData = await updateXML(dataToUpdate, this.updateStatus);

                if(sendToBossData){
                    let cad_file = null;
                    let timezone = null;
                    if(sendToBossData.cad){
                        timezone = sendToBossData.cad.timezone;
                        sendToBossData.cad.attachments.filter((r) => {
                            if(r.att_column_name == 'CAD依頼書結合ファイル'){
                                cad_file = r.path;
                                return;
                            }
                        })
                    }
                    if(sendToBossData.xml_bundle_arr){
                        let newdata = []
                        sendToBossData.xml_bundle_arr.filter((res) => {
                            // ? GET 357 FILE
                            if(res.boss_code == '357'){
                                res.file = cad_file;
                            }else{
                                res.file = null;
                            }
                            // ? BOSS REMARKS
                            res.remarks = res.cad_remarks;

                            if(timezone == 'Asia/Singapore'){
                                res.received_day = this.addOneHour(res.received_day)
                            }else{
                                res.received_day = moment(res.received_day).format('YYYY/MM/DD HH:mm:ss')
                            }

                            res.finish_day = res.finish_day ? moment(res.finish_day).format('YYYY/MM/DD HH:mm:ss') : '',
                            res.plannerCode = "";
                            newdata.push(res)
                        })
                        // console.log(newdata)
                        if(this.accept){
                            let tempdata = []
                            newdata.filter((res) => {
                                if(res.boss_code == '357'){
                                    tempdata.push(res)
                                }
                            })
                            newdata = tempdata;
                            // console.log(newdata)

                        }
                        // ? SEND DATA TO BOSS
                        if(latestData.isBossChecked == 1) {
                            await this.saveToLocal();
                            // console.log(newdata, 'newdata')
                            // return;
                        }else await this.triggerSocketBossSending(newdata, "HRD Accept");
                    }
                }
                


        },
        async saveToXmlTable(data){
            // console.log(data.house_type_name, data,'test')
            // NOTE : boss code sendings
            // this.HRDID = generateHRDID();
            // NOTE : GATHER Master Zumen type (by boss code)
            let bossCode = 357;
            let zumen = {};
            let created_date = moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')
            let final_plan = null;
            let revision_type = null;
            let plan_status = null;

            // CONDITION FOR FINAL PLAN
                if(data.final_plan == '1'){
                    final_plan = '003'
                }else if(data.final_plan == '2'){
                    final_plan = '001'
                }else if(data.final_plan == '3'){
                    final_plan = '002'
                }else{
                    final_plan = null
                }

            // CONDITION FOR REVISION/REQUEST TYPE
                if(data.revision_type == '1'){
                    revision_type = '新規(A)';
                }else{
                    if(data.revision_type == '5'){
                        if(data.gravity_type == '5Z'){
                            revision_type = '新規(A)';
                        }
                    }else if(data.revision_type == '7'){
                        if(data.gravity_type == '5Cad'){
                            revision_type = '新規(A)';
                        }
                    }else{
                        // if(data.kakouirai_reason == 1 || data.kakouirai_reason == 2){
                        // if(data.kakouirai_reason == 1){
                        //         revision_type = '追変(TH)';
                        //     }
                        // else{
                        //     // revision_type = '変更(C)';
                        //     if(data.revision_type == '5'){
                        //         if(data.gravity_type == '5Z'){
                        //             revision_type = '新規(A)';
                        //         } else {
                        //             revision_type = '変更(C)';
                        //         }
                        //     }
                        // }
                        if(data.kakouirai_reason == 1 ){
                            revision_type = '追変(TH)';
                        } else if(data.kakouirai_reason == 2 || data.kakouirai_reason == 3  || data.kakouirai_reason == 4 || data.kakouirai_reason == 5 ){
                            if(data.revision_type == '5'){
                                if(data.gravity_type == '5Z'){
                                    revision_type = '新規(A)';
                                } else {
                                    revision_type = '変更(C)';
                                }
                            }
                        } else{
                            revision_type = '変更(C)';
                        }

                    }
                }

            // CONDITION FOR PLAN STATUS
                if(data.expected_house_raising_date){
                    plan_status = 'Already Kakouirai';
                }else{
                    plan_status = 'Before Kakouirai'
                }


            try {
                zumen = await getZumenType(bossCode);
                if (zumen) {
                    console.log(zumen, 'zumen');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // NOTE : GET BUNDLE Schedule ------ no need for boss code 357
            // getBundleSchedule('2023-09-02 12:30:28');

            // NOTE : ASSIGN TO BOSS DATA OBJECT FOR SENDING
                this.boss_data = {
                        cad_request_id: data.id,
                        HRD_ID: data.hrd_id,
                        code_number: data.customer_code,
                        plan_number: data.revision_number,
                        shio_no: null,
                        denki_no: null,
                        plan_type_name: zumen.zumentype_name,
                        boss_code: zumen.zumentype_id,
                        hrdProcess: data.hrd_process ? data.hrd_process : null,
                        icad_plan: 0,
                        action_req: 'ADD',
                        received_day: created_date,
                        bracket_name: null,
                        original_due_day: null,
                        due_day: null,
                        bundle: null,
                        bundle_date: null,
                        bundle_schedule: null,
                        finish_day: null,
                        cademaildate: null,
                        cad_bundle: null,
                        cad_bundle_date: null,
                        cad_bundle_schedule: null,
                        sender: data.hrd_accepted_user_id,
                        doc_arrangement: '357',
                        remarks: null,
                        pers_hp_code: null,
                        house_type: data.house_type_name,
                        created_at: created_date,
                        date_updated: created_date,
                        Department: null,
                        Section: null,
                        Team: null,
                        shiyousho_receive: null,
                        sekisan_receive: null,
                        kurosu_receive: null,
                        sqc_receive: null,
                        fp: final_plan,
                        updated_at: null,
                        updated_by: null,
                        updated_by_code: null,
                        updated_ip: null,
                        change_at: null,
                        change_by: null,
                        change_ip: null,
                        deleted_by: null,
                        deleted_ip: null,
                        deleted: null,
                        request_type : revision_type,
                        plan_status : plan_status,
                }
            // NOTE : SEND TO CAD REQUEST XML
                await saveToXML(this.boss_data);
                // console.log(this.boss_data)

                // newdata.file = this.newCadRequest.attachments.filter((r) => {
                //     if(r.att_column_name == 'CAD依頼書結合ファイル'){
                //         return r;
                //     }
                // })[0].path;
                // newdata.remarks = this.newCadRequest.hrd_process == 1 ? 'HRDミスの訂正' : '';
                // console.log(newdata, 'newdata' , this.newCadRequest)

                // await this.triggerSocketBossSending(newdata);
        },

        async saveToXmlTable_357(data){
            let bossCodes = [
                        {
                            boss_code : '357',
                            boss_remarks : null,
                            pers_hp_code : null,
                            doc_arrangement : 'CADRequestForm', // CADRequestForm
                            sched_for : '357_',
                        }
            ]
            let created_date = moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')
            try {
                let bossPromise = bossCodes.map(async (boss) => {
                    let zumen = {};
                    // let revision_type = null;
                    let plan_status = null;
                    // GET BRACKET AND SCHEDULE

                    // NOTE : boss code sendings
                    boss.HRD_ID = generateHRDID(boss.boss_code);


                    // CONDITION FOR FINAL PLAN
                        if(data.final_plan == '1'){
                            boss.fp = '003'
                        }else if(data.final_plan == '2'){
                            boss.fp = '001'
                        }else if(data.final_plan == '3'){
                            boss.fp = '002'
                        }else{
                            boss.fp = null
                        }

                        let rem = null;
                        if(data.hrdProcess == 1){
                            rem = 'HRDミスの訂正';
                        }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason != '' && this.$store.state.cadRequestBasicInformation.kakouirai_reason != null){
                            if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 1){
                                rem = '追加変更（TH)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 2){
                                rem = '加工ストップ後追加変更申請で対応（TH)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 3){
                                rem = '加工ストップ後再加工依頼で対応 (RE-ORDER)';
                            }else if(this.$store.state.cadRequestBasicInformation.kakouirai_reason == 4){
                                rem = '長期物件・再加工依頼（RE-ORDER)';
                            }
                        }else{
                            rem = null;
                        }

                        if(rem){
                            if(boss.boss_remarks){
                                boss.cad_remarks = `${boss.cad_remarks} / ${boss.boss_remarks}`
                            }else{
                                boss.cad_remarks = rem
                            }
                        }else{
                            boss.cad_remarks = boss.boss_remarks;
                        }

                        // BUNDLE SCHED
                        if(boss.boss_code != '357'){
                            let bundleSchedule = await getBundleSchedule(created_date);
                            let day = null;
                            let hr = null;
                            if(bundleSchedule){
                                // Given date and time
                                let orig_day = moment(created_date).format('YYYY-MM-DD HH:mm:ss');
                                if(boss.sched_for){
                                    day = boss.sched_for + 'day';
                                    hr = boss.sched_for + 'hr';
                                // Find the next Saturday
                                    while (moment(orig_day).format('ddd') !== bundleSchedule[day]) {
                                        orig_day = moment(orig_day).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                                    }
                                    boss.bracket_name = bundleSchedule.bracket_name
                                    boss.original_due_day = moment(orig_day).format(`YYYY-MM-DD ${bundleSchedule[hr]}:00:00`); // CAD_DAY
                                    boss.due_day = boss.original_due_day;
                                }else{
                                    boss.bracket_name = null;
                                    boss.original_due_day = null;
                                    boss.due_day = null;
                                }

                            }
                        }else if(boss.boss_code == '357'){
                            boss.bracket_name = null;
                            boss.original_due_day = null;
                            boss.due_day = null;

                        }

                        
                    // CONDITION FOR PLAN STATUS
                    if(this.$store.state.cadRequestBasicInformation.expected_house_raising_date != null){
                        boss.plan_status = 'Already Kakouirai';
                    }else{
                        boss.plan_status = 'Before Kakouirai'
                    }
                    // NOTE : GATHER Master Zumen type (by boss code)
                        if(boss.boss_code){
                            zumen = await getZumenType(boss.boss_code);
                            if(zumen){
                                boss.plan_type_name = zumen.zumentype_name;
                                boss.boss_code = zumen.zumentype_id;
                            }
                        }else{
                            boss.plan_type_name = null;
                            boss.boss_code = null;
                        }
                            boss.request_type = data.request_type;
                            boss.cad_request_id = data.id;
                            boss.code_number = data.customer_code;
                            boss.plan_number = data.revision_number;
                            boss.shio_no = null;
                            boss.denki_no = null;
                            boss.hrdProcess = data.hrd_process ? data.hrd_process : null;
                            boss.icad_plan = 0;
                            boss.action_req = 'ADD';
                            boss.received_day = created_date;
                            boss.bundle = null;
                            boss.bundle_date = null;
                            boss.bundle_schedule = null;
                            boss.finish_day = null;
                            boss.cademaildate = null;
                            boss.cad_bundle = null;
                            boss.cad_bundle_date = null;
                            boss.cad_bundle_schedule = null;
                            boss.sender = data.hrd_accepted_user_id;
                            // boss.doc_arrangement = '357';
                            boss.remarks = null;
                            // boss.pers_hp_code = null;
                            boss.house_type = data.house_type_name;
                            boss.created_at = created_date;
                            boss.date_updated = created_date;
                            boss.Department = null;
                            boss.Section = null;
                            boss.Team = null;
                            boss.shiyousho_receive = null;
                            boss.sekisan_receive = null;
                            boss.kurosu_receive = null;
                            boss.sqc_receive = null;
                            boss.updated_at = data.updated_at ? moment(data.updated_at).format('YYYY-MM-DD HH:mm:ss') : null;
                            boss.updated_by = null;
                            boss.updated_by_code = null;
                            boss.updated_ip = null;
                            boss.change_at = null;
                            boss.change_by = null;
                            boss.change_ip = null;
                            boss.deleted_by = null;
                            boss.deleted_ip = null;
                            boss.deleted = null;
                            boss.cad_remarks = boss.boss_remarks;
                            return boss
                });
                let resolvedBoss = await Promise.all(bossPromise);
                // await saveToXML(resolvedBoss);
                await saveToXML(
                    resolvedBoss,
                    false,
                    this.editRecord,
                    this.basicInfo,
                );
                // console.log(resolvedBoss, 'resolvedBoss')


            } catch (error) {
                alert(error);
            }


        },
        
        async triggerSocketBossSending(newdata, status){
            let sendToBossData = [];
            await newdata.forEach(element => {
                if (element.boss_code != '' && element.boss_code != null && 
                    element.boss_code != 'SITE' && element.boss_code != 'SITEM' && 
                    element.boss_code != 'HPSP' && element.boss_code != 'PD9' && element.boss_code != '128' && 
                    element.boss_code != 'S89' && element.boss_code != 'ZEH' && element.boss_code != 'GXS') {
                    let due_day = null;
                    due_day = element.due_day ? moment(element.due_day).format('YYYY/MM/DD HH:mm:ss') : '';
                    let data = {
                        hrdId: element.HRD_ID,
                        customerCode: element.code_number,
                        planType: element.boss_code,
                        receivedDay: element.received_day,
                        planNumber: element.plan_number,
                        finishPlanDay: element.due_day ? moment(element.due_day).format('YYYY/MM/DD HH:mm:ss') : '',
                        finishedDay: '',
                        remarks: element.remarks,
                        plannerCode: "",
                        file: element.file,
                        action: status,
                        cad_id: element.id
                    }
                    sendToBossData.push(data);
                }
            });
            // console.log(sendToBossData, newdata, 'boss')
            // Try-catch block outside the forEach loop
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        bossdata: sendToBossData,
                        uniqId: this.loggedInUser.uniqId
                    },
                    functionType: 'sendToBossDynamic'
                });
            } catch (error) {
                console.log(error, 'socket error');
            }
            // let sendToBossData = {
            //     hrdId : newdata.HRD_ID,
            //     customerCode : newdata.code_number,
            //     planType : newdata.boss_code,
            //     receivedDay : newdata.received_day,
            //     planNumber : newdata.plan_number,
            //     finishPlanDay : newdata.finish_day ? moment(newdata.finish_day).format('YYYY/MM/DD HH:mm:ss') : '',
            //     finishedDay : newdata.finish_day ? moment(newdata.finish_day).format('YYYY/MM/DD HH:mm:ss') : '',
            //     remarks : newdata.remarks ? newdata.remarks : '',
            //     plannerCode : "",
            //     file : newdata.file,
            //     action : newdata.status,
            //     cad_id: newdata.id
            // }
            // try {
            //     console.log('emit')
            //     this.$socket.emit('newUpdate', { dispatchType: this.env.request, data: {
            //         bossdata: sendToBossData,
            //         uniqId: this.loggedInUser.uniqId
            //     },
            //         functionType: 'sendToBoss'
            //     })
            // } catch (error) {
            //     console.log(error, 'socket error')
            // }
        },

        addOneHour(received_day){
            // Assuming newdata.received_day contains the date you want to manipulate
            const originalDate = moment(received_day);

            // Add 1 hour to the original date
            const newDate = originalDate.add(1, 'hours');

            // Format the new date as 'YYYY/MM/DD HH:mm:ss'
            const formattedDate = newDate.format('YYYY/MM/DD HH:mm:ss');
            return formattedDate;
        },
        formatDateTime(dateParam) {
            const date = new Date(dateParam);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        getBasicInfo(){
            try {
                axios({
                    method:  "POST",
                    url: "api/basic/getBasicInfo",
                    data : {
                        cad: this.editRecord
                    }
                }).then(({data}) => {
                    this.basicInfo = data;
                    console.log(this.basicInfo)
                })
            } catch (error) {
                
            }
        },
        
    // NOTE : BOSS REGISTRATION AND UPLOADING FUNCTIONS
        async openDialogForRegistration(data, reg){
            const planCreatorId = data.created_by; 
            const matchedPlanner = this.PH6Planners.find(planner => {
                console.log(planner, 'planner sa match')
                return Number(planner.iduser) === Number(planCreatorId);
            });
            this.$store.state.ph6User = matchedPlanner ? true : false;
            this.accept = reg
            this.overlay = true;
            const created_date = this.formatDateTime(data.created_at);
            // SOCKET FOR GETTING SCHEDULE IN HRDAPPS49
            try {
                await this.$socket.emit('newUpdate', {
                dispatchType: this.env.request,
                data: {
                    date: created_date,
                    basic_info : this.basicInfo,
                    latestData: data,
                    uniqId: this.loggedInUser.uniqId
                },
                functionType: 'boss_schedule'
                });
                // this.overlay = false;
            } catch (error) {
                console.log(error, 'socket error');
            }
            
        },
    
        hrdAcceptAtt(){
            // console.log('test')
            this.overlay = true;
            axios({
                method: 'post',
                url: 'api/accept-plan',
                data: {
                    existing : this.editRecord,
                    loggedInUser : this.loggedInUser,
                    register_date : this.$store.state.registerDate,
                }
            }).then(async ({data}) => {
                if(this.accept) { //accept
                    this.updateStatus = 'HRD Accept';
                    this.acceptBtn = false;
                    this.regBtn = true;
                } else {//register
                    this.updateStatus = 'Register';
                    this.acceptBtn = false;
                    this.regBtn = false;
                }
            

                // await this.convertB64(data);
                // if(data.xml_bundle == null){
                //     await this.saveToXmlTable_357(data.latest).then(async () => {
                //         await this.hrdAcceptAtt()
                //     });
                // }else{
                    this.newCadRequest = data.latest;
                    this.newCadRequest.file = data.file;
                    this.newCadRequest.kakouirai = data.kakou;
                    this.newCadRequest.timezone = data.latest.timezone;
                    this.newCadRequest.basic_info = data.basicInfo;
                    await this.updateXMLTable(this.newCadRequest);
                // }
                await this.getView();

                // this.overlay = false;
            })
        },

        async toggleUpdateCadRequest(){
            this.overlay = true;
            this.downloadBtn = true;
            // console.log(this.editRecord, 'editRecord')
            this.countPageUpdate = 0;
            let downloadUrl = null;
            let id = this.editRecord.id;
            await axios({
                method : 'GET',
                url : `update_merge/${id}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(async ({data}) => {
                console.log(data, "dataaaaaaaaa")
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    // loop through the PDFs and add each one to the merged document
                    for (const pdf of data.fileBuffer) {
                    // decode the base64-encoded PDF
                        if(pdf){
                            const pdfBytes = Buffer.from(pdf, 'base64');
                            // create a PDFDocument object from the bytes
                            const pdfDoc = await PDFDocument.load(pdfBytes);
                            // loop through each page in the PDF and add it to the merged document
                            const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                pages.forEach((page) => {
                                    mergedPdf.addPage(page);
                                    this.countPageUpdate += 1;
                                });
                            }
                    
                            // save the merged PDF to a file
                            const mergedPdfBytes = await mergedPdf.save();
                            // Create a Blob object with the merged PDF data
                            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                            // Create a download URL for the Blob
                            downloadUrl = URL.createObjectURL(blob);
                            resolve(mergedPdfBytes)
                        }
                            // window.open(downloadUrl, '_blank');
                            // console.log(id, "merging id")
                            this.multipleFile = [];
                            await this.saveUpdatedMergedFile(downloadUrl, id)
                            await this.updateMergeCadPira(data.cadPira,id);

                })
            })
        },
        saveUpdatedMergedFile(blobUrl, id){
            fetch(blobUrl)
                .then(response => response.blob())
                .then(blob => {
                    let rev1 = null;
                    let rev2 = null;
                    let explodeRevision = this.editRecord.revision_number.split("-")
                    if(explodeRevision[0].length == 1){
                        rev1 = `0${explodeRevision[0]}`;
                    }else{
                        rev1 = explodeRevision[0]
                    }

                    if(explodeRevision[1].length == 1){
                        rev2 = `0${explodeRevision[1]}`;
                    }else if(explodeRevision[1].length == 2){
                        if(/[a-zA-Z]/.test(explodeRevision[1])){
                            rev2 = `0${explodeRevision[1]}`;
                        }else{
                            rev2 = explodeRevision[1];
                        }
                    }else{
                        rev2 = explodeRevision[1];
                    }
                    const file = new File([blob], 'merged.pdf');
                    this.pathName = this.editRecord.customer_code;
                    this.mergedFilename = `${this.editRecord.customer_code}-${rev1}${rev2}-`;
                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageUpdate);
                        formData.append('basic', JSON.stringify(this.basicInfo));
                        formData.append('cad', JSON.stringify(this.editRecord));

                        axios({
                            method : "POST",
                            url : "api/update-merge",
                            data : formData
                        }).then(async ({data}) => {
                            // console.log(response, "res")
                            window.open(`open_file/${data.FileAttachment.id}`,"_blank");
                        })
                    })
        },
        updateMergeCadPira(data, id){
            this.countPageCadPira = 0;
            // let id = this.existingRevisions[index].id;
            let downloadUrl = null;
                return new Promise(async(resolve)=>{
                    // create a new PDF document
                    const mergedPdf = await PDFDocument.create();
                    if(data){
                        // loop through the PDFs and add each one to the merged document
                        for (const pdf of data) {
                        // decode the base64-encoded PDF
                            if(pdf){
                                const pdfBytes = Buffer.from(pdf, 'base64');
                                // create a PDFDocument object from the bytes
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                // loop through each page in the PDF and add it to the merged document
                                const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                    pages.forEach((page) => {
                                        mergedPdf.addPage(page);
                                        this.countPageCadPira += 1;
                                    });
                                }
                        
                                // save the merged PDF to a file
                                const mergedPdfBytes = await mergedPdf.save();
                                // Create a Blob object with the merged PDF data
                                const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
                                // Create a download URL for the Blob
                                downloadUrl = URL.createObjectURL(blob);
                                resolve(mergedPdfBytes)
                            }
                                await this.updateMergedCadPiraFile(downloadUrl, id)
                                this.multipleFile = [];
                                // console.log(id, downloadUrl, "2")
                                
                    }else{
                        console.log(data, "no data")
                    }

                })
        },

        async updateMergedCadPiraFile(blobUrl, id){
            await fetch(blobUrl)
                .then(response => response.blob())
                .then(async blob => {
                    const file = new File([blob], 'merged.pdf');

                    // Create a FormData object and append the file
                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('pathName', this.pathName);
                        formData.append('fileName', this.mergedFilename);
                        formData.append('id', id);
                        formData.append('pages', this.countPageCadPira);

                        await axios({
                            method : "POST",
                            url : "api/update-merge-cadpira",
                            data : formData
                        }).then(async response => {
                            // console.log(response, "res")
                            await setTimeout(() => {
                                this.getView();
                                this.overlay = false;
                                this.fileAttDialog = false;
                            }, 4000);
                        })
                    })

        },

        toggleEditCadRequest(value){
            // console.log(value, 'val')
            this.$emit('editCadRequest', value)
        },

        getUsers(){
            axios({
                method : 'post',
                url : 'api/get_users'
            }).then( (res) => {
                // console.log(this.users)
                this.users = res.data
            })
        },
        searchPlan(){
            this.viewtable = []
            axios({
                method : 'POST',
                url : 'api/view-table',
                data : {
                    dateFilter : this.filterDateSelection,
                    hrd_accept : this.hrdAcceptSelect,
                    express : this.expressSelect,
                    dateFrom : this.dateFrom,
                    dateTo : this.dateTo,
                    loggedInUser : this.loggedInUser,
                    search: this.search
                }
            }).then( res => {
                this.viewtable = res.data.result;
                this.totalRecord = res.data.totalRecords
                this.viewtable.forEach((element, index) => {
                    element.attachments.forEach((el, ii) => {
                        if(el.att_column_name == 'CAD依頼書結合ファイル'){
                            // Remove the element from its current index
                            let arr = element.attachments.splice(ii, 1)[0];
                            // Insert the element at the target index
                            element.attachments.splice(0, 0, arr)
                        }

                        if(el.att_column_name == 'CAD依頼書'){
                            // Remove the element from its current index
                            let arr = element.attachments.splice(ii, 1)[0];
                            // Insert the element at the target index
                            element.attachments.splice(1, 0, arr)
                        }

                    })
                    // RADIO 8
                    if(element.revision_type == '8' && /[a-zA-Z]/.test(element.revision_number)){
                        element.cad = 1;
                    } else {
                        element.cad = 0;
                    }
                });
                // console.log(res.data,'res')

                this.viewtable = this.viewtable.filter( r=> r.created_at = r.created_at ? moment(r.created_at).format("YYYY-MM-DD HH:mm:ss") : '')
                this.overlay = false;
                // if (this.viewtable.length === this.totalRecord) {
                //     this.overlay = false;
                // }
                // console.log(this.viewtable,'viewtable')
            });
                
        },
         // REVISION NUMBER WITH OR WITHOUT LETTER, IT WILL ALWAYS OUTPUT 1234567-2024-1-0(A)
        ConvertPlanNumber(value){
            // console.log(value,'value')
            let newPlanNumber = '';
            let customerCode = value.slice(0,12)
            let revNumber = value.slice(13)
            if (revNumber.match(/-/g)) {
                newPlanNumber = revNumber;
            } else {
                let match = revNumber.match(/[a-zA-Z]+|[0-9]+/g);
                if (match !== null) {
                    let a = parseInt(match[0].substr(0, 2));
                    let b = parseInt(match[0].substr(2));
                    let c = '';
                    if (match.length > 1) {
                        c = match[1];
                    }
                    newPlanNumber = `${a}-${b}${c}`;
                } else {
                newPlanNumber = revNumber; // or some other default value
                }
            }
            this.constructionCode = customerCode + '-' + newPlanNumber;
            return this.constructionCode;
        },

        updateTwoDaysBefore() {
            const currentDate = new Date(this.currentDate);
            currentDate.setDate(currentDate.getDate() - 7);
            this.dateFrom = currentDate.toISOString().substr(0, 10);
        },
        getTimezoneOffset() {
            return new Date().getTimezoneOffset();
        },
        getTimezoneOffset() {
            return new Date().getTimezoneOffset();
        },
        multipleCheckBox(item){
        // console.log(this.$store.state.previousAttachmentFiles, "previousAttachmentFiles")
        // console.log(item.selectedCheckBox,'selectedCheckbox')    
        // this.attDialogList.filter((item) => {
        //     if(item.att_column_name == 'CAD依頼書結合ファイル' || item.att_column_name == '現況図（CADデータ）'){
                if(item.selectedCheckBox){
                    this.multipleFile.push(item)
                }else{
                    const index = this.multipleFile.findIndex(obj => obj.id === item.id);
                    this.multipleFile.splice(index, 1);
                }
            // }
        // })
        
        },
        closeFileAtt(){
            this.fileAttDialog = false;
            this.multipleFile = [];
            this.acceptBtn = false;
            this.regBtn = false;
            // this.overlay = false;
        },

        // downLoadMultiple(){
        //     let inTime = 0
        //     this.acceptBtn = true;
        //     this.regBtn = true;
        //     const toastTimeout = this.multipleFile.length * 1000; // 1 second per file
        //     AWS.config.update({
        //         region: "us-east-2",
        //         accessKeyId: process.env.MIX_AWS_ACCESS_KEY_ID,
        //         secretAccessKey: process.env.MIX_AWS_SECRET_ACCESS_KEY,
        //     });

        //     let s3 = new AWS.S3();

        //     // this.overlay = true;
        //     const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
        //     // const s3 = new AWS.S3();
        //     // Set a timeout before starting the download
        //         // Start downloading files
        //         const downloadPromises = this.multipleFile.map((file) => {
        //             this.toastVisible = true;
        //             return new Promise((resolve, reject) => {
        //                     this.$toast.info("Downloading! Please wait...", {
        //                         position: "top-right",
        //                         timeout: 10000,
        //                         closeOnClick: true,
        //                         pauseOnFocusLoss: false,
        //                         pauseOnHover: false,
        //                         draggable: true,
        //                         draggablePercent: 0.91,
        //                         showCloseButtonOnHover: true,
        //                         hideProgressBar: false,
        //                         closeButton: "button",
        //                         icon: true,
        //                         rtl: false
        //                     });

        //                 const params = {
        //                     Bucket: bucketName,
        //                     Key: file.path,
        //                 };
        //                 s3.getObject(params, (error, data) => {
        //                     if (error) {
        //                         reject(error);
        //                     } else {
        //                         const blob = new Blob([data.Body], { type: data.ContentType });
        //                         const url = URL.createObjectURL(blob);
        //                         const link = document.createElement('a');
        //                         link.href = url;
        //                         link.download = file.filename;
        //                         link.click();
        //                         resolve();
        //                         this.toastVisible = false
        //                         this.$toast.clear();
        //                     }
        //                 });
        //             });
        //         });
        //             Promise.all(downloadPromises)
        //                 .then(() => {
        //                     // this.acceptBtn = true;
        //                     this.$toast.success("Download(s) complete!", {
        //                         position: "top-right",
        //                         timeout: 2970,
        //                         closeOnClick: true,
        //                         pauseOnFocusLoss: true,
        //                         pauseOnHover: false,
        //                         draggable: true,
        //                         draggablePercent: 0.91,
        //                         showCloseButtonOnHover: true,
        //                         hideProgressBar: true,
        //                         closeButton: "button",
        //                         icon: true,
        //                         rtl: false
        //                     });

        //                 })
        //                 .catch((error) => {
        //                     console.error('Error downloading files:', error);
        //                 });
                // After all downloads are finished

        
        // NOT WORKING MULTIPLE DOWNLOAD - NEED TO REMOVE THE REVOKE CODE TO WORK
        // const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
        // const s3 = new AWS.S3();

        // const downloadPromises = this.multipleFile.map((file) => {
        //     return new Promise((resolve, reject) => {
        //         const params = {
        //             Bucket: bucketName,
        //             Key: file.path
        //         };

        //         s3.getObject(params, (error, data) => {
        //             if (error) {
        //                 reject(error);
        //             } else {
        //                 // Create a Blob from the data
        //                 // const fileExtension = file.filename.split('.').pop().toLowerCase();
        //                 // const contentType = fileExtensionsToContentType[fileExtension] || 'application/octet-stream';
        //                 const blob = new Blob([data.Body], { type: 'application/pdf' });

        //                 // Create a URL for the Blob
        //                 const url = URL.createObjectURL(blob);

        //                 // Create a link element and simulate a click to download the file
        //                 const link = document.createElement('a');
        //                 link.href = url;
        //                 link.download = file.filename;
        //                 link.click();

        //                 // Clean up the URL and resolve the promise
        //                 URL.revokeObjectURL(url);
        //                 resolve();
        //             }
        //         });
        //     });
        // });

        // Promise.all(downloadPromises)
        //     .then(() => {
        //         this.overlay = false;
        //     })
        //     .catch((error) => {
        //         console.error('Error downloading files:', error);
        // });

    // <-- Old Download -- >
        // const bucketName = 'cadrequest.files'; // Replace with your actual bucket name
        // const s3 = new AWS.S3();
        // const zip = new JSZip();

        // const downloadPromises = this.multipleFile.map((file) => {
        //     console.log(file,'file')

        //     return new Promise((resolve, reject) => {
        //         const params = {
        //         Bucket: bucketName,
        //         Key: file.path
        //         };

        //         s3.getObject(params, (error, data) => {
        //             if (error) {
        //                 reject(error);
        //             } else {
        //                 zip.file(file.filename, data.Body, { binary: true });
        //                 resolve();
        //             }
        //         });
        //     });
        // });

        // Promise.all(downloadPromises)
        //     .then(() => {
        //         return zip.generateAsync({ type: 'blob' });
        //     })
        //     .then((content) => {
        //         saveAs(content, this.customerFileCode+'-attachments.zip');
        //             this.overlay = false;
        //     })
        //     .catch((error) => {
        //         console.error('Error downloading files:', error);
        //     });
    // <-- End Old Download -- >

            // this.multipleFile.forEach((file) => {
            //     const params = {
            //       Bucket: bucketName,
            //       Key: file.path,
            //     };
            //     console.log(params);

            //     s3.getObject(params, (error, data) => {
            //       if (error) {
            //         console.error('Error retrieving file:', error);
            //         return;
            //       }

            //       const fileData = data.Body;
            //       const blob = new Blob([fileData]);

            //       const link = document.createElement('a');
            //       link.href = URL.createObjectURL(blob);
            //       link.setAttribute('download', file.path);
            //       link.click();
            //     });
            // });
        // },

        downLoadMultiple() {
            this.acceptBtn = true;
            this.regBtn = true;
            const toastId = this.$toast.info("Downloading! Please wait...", {
                    timeout: 20000,
                    // duration: 0, // Prevent auto-dismissal
                    closeOnClick: false, // Optional: prevent closing on click
                    pauseOnHover: true, // Optional: pause on hover
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
            // Create an array to hold all download promises
            const downloadPromises = this.multipleFile.map(file => {
                const url = `/download-file?key=${encodeURIComponent(file.path)}`;
                return axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // Important
                })
                .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = file.filename; // Use the filename provided
                    link.click();
                    URL.revokeObjectURL(link.href); // Clean up the URL object
                    this.$toast.success(`Successfully downloaded ${file.filename}`, {
                        style: {
                            width: '700px',
                            fontSize: '14px',
                            height: '85px',
                        }
                    });
                })
                .catch(error => {
                    console.error('Error downloading file:', error);
                    // this.$toast.error(`Error downloading ${file.filename} : ${error.message} : PLEASE, RE-UPLOAD!`, {
                    this.$toast.error(`Error downloading ${file.filename} : Please request to planner to re-upload the data.`, {
                        style: {
                            width: '710px',
                            height: '90px',
                        }
                    });
                });
            });

            // Antayin matapos lahat ng downloads bago i-close kaya wag kang atat
            Promise.allSettled(downloadPromises)
                .finally(() => {
                    // Dismiss the info toast after all downloads are complete
                    this.$toast.dismiss(toastId);
                    // this.acceptBtn = true;
                    // this.regBtn = true;
                });
        },

        toggleSnackBar(){
            this.snackbar.show = true;
            this.snackbar.text = 'Copied!!';
        },
        copyControlNumber(val){
            var copyText = val;
            copy(copyText, {
                debug: true,
            });
            this.toggleSnackBar()
        },
        goToMain(customer_code){
            this.$store.commit('SET_EXISTING_REVISIONS', [])
            this.$store.commit('setCadRequestBasicInformation', {})
            this.$store.state.customerCodeFromView = customer_code
            this.$store.state.getXml = customer_code
            // this.$store.state.cadRequestBasicInformation.construction_code = customer_code;
            // console.log(this.$store.state.cadRequestBasicInformation)
            // this.$router.push({name : 'main'})

            this.getAuthorization(customer_code)
            
            // ----- FIRST APPROACH IN AUTHORITY API -----
            // const url = `http://boss.ichijo.jp/bossservice2/rest/customer/getCustomerAuthority/${customer_code}`
            // const code = this.loggedInUser.user_id.padStart(5,'0')

            // axios.post('api/getAuthority',{
            //     url : url,
            //     code: code
            // }).then(response => {
            //     if (response.data == 2 || response.data == 1 || this.loggedInUser.type == 'Admin') {
            //         this.$store.state.customerCodeFromView = customer_code
            //         this.$store.state.getXml = customer_code
            //         this.$router.push({name : 'main'})
            //     } else {
            //         alert('Unauthorized access attempt')
            //     }
            // }).catch(error => {
            //     alert('お客様権限取得失敗')
            // });
        },

        async getAuthorization(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        customerCode : data,
                        logIn_id : this.loggedInUser.user_id.padStart(5,'0')
                    },
                    functionType: 'get_authority'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },
        
        viewFile(id){
            this.overlay = true;
            axios({
                method:'get',
                url:`open_file/${id}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(()=>{
                // console.log(data)
                window.open(`open_file/${id}`,"_blank");
                this.overlay = false;
            })
        },
        
        // downLoadFile(data,id, type) { // Mas mabilis to para sa akin
        //     this.overlay = true;
        //     axios({
        //         method: 'get',
        //         url: `download_file/${id}/${type}`,
        //         responseType: 'blob', // Important for handling binary data
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(response => {
        //         const url = window.URL.createObjectURL(new Blob([response.data]));
        //         const link = document.createElement('a');
        //         link.href = url;
        //         link.setAttribute('download', `${data.filename}`); // Set the file name
        //         document.body.appendChild(link);
        //         link.click();
        //         link.remove();
        //         this.overlay = false;
        //     }).catch(error => {
        //         console.error("Download error:", error);
        //         this.overlay = false;
        //     });
        // },

        downLoadFile(id, type){
            // axios.get(`download_file/${id}/${type}`,)
            this.overlay = true;
            axios({
                method:'get',
                url:`download_file/${id}/${type}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(()=>{
                window.open(`download_file/${id}/${type}`,"_blank")
                this.overlay = false;
            })
        },

        openFileAttDialog(item){
            console.log(item,'iteeeeeeeeeeeeeeem')
            this.$store.state.getBossiCad = item;
            this.$store.state.getXml = item.customer_code;
            let getSiteBoss = item.site_layout_option;
            this.repdfBtn = false;
            this.downloadBtn = false;
            this.bossSchedBtn = false;
            item.house_type_name = item.name
            item.whole_date = item.created_at
            this.editRecord = item
            this.getBasicInfo();
            this.toggleEditCadRequest(item)
            this.$emit('repdf', item)
            this.customerFileCode = item.customer_code;
            this.totalPages = 0;
            this.fileAttDialog = true;
            this.attDialogList = item.attachments.filter((r) => {
                if(r.filename.includes(item.customer_code)){
                    if(r.att_column_name == 'CAD依頼書結合ファイル'){
                        this.totalPages = r.no_of_pages
                        this.downloadBtn = true;
                        this.repdfBtn = true;
                        this.bossSchedBtn= true;
                    } else if(item.revision_type == '10') {
                        this.totalPages = r.no_of_pages
                    }
                    let type = r.filename.split('.')
                    r.fileType = type[type.length - 1];
                    return r
                }
            });

        // IF THERE IS MULTIPLE FILE NAME OF PDF
            let v = this.attDialogList.filter((item) => {
                return item.att_column_name == 'CAD依頼書結合ファイル'
            });

            let g = this.attDialogList.filter((item) => {
                return item.att_column_name == 'CAD依頼書';
            })

            // console.log(v,'CAD依頼書結合ファイル')
            // console.log(g,'CAD依頼書')
            if(v.length > 1 || g.length > 1){
                this.repdfBtn = false;
                this.downloadBtn = false;
            } else {
                this.repdfBtn = true;
                this.downloadBtn = true;
            }
        //

        // IF THERE IS NO 357 || CAD DOCU - ENABLE REPDF
            const notExists = item.attachments.every(obj => !Object.values(obj).includes('CAD依頼書結合ファイル'));
            const notExistsCad = item.attachments.every(obj => !Object.values(obj).includes('CAD依頼書'));
            if(notExists || notExistsCad) this.repdfBtn = false;
        //

        // DEFAULT CHECK IF THIS IS THE COLUMN NAME FOR VIEW TABLE AND PLANNER TABLE
            this.attDialogList.filter((item) => {
                // if(item.att_column_name == 'CAD依頼書結合ファイル' || item.fileType != 'pdf'){
                if(item.att_column_name == 'CAD依頼書結合ファイル' || (item.att_column_name == '現況図（CADデータ）' && getSiteBoss != 'option1')){
                    if(item.selectedCheckBox = true){
                        this.multipleFile.push(item)
                    }else{
                        const index = this.multipleFile.findIndex(obj => obj.id === item.id);
                        this.multipleFile.splice(index, 1);
                    }
                } else if(item.fileType != 'pdf'){
                    this.multipleFile.push(item)
                    item.selectedCheckBox = false;
                }
            })
            // console.log(this.editRecord,'editRecord')
        },

        // Store(){
        //     if(this.$refs.Store.validate()){

        //     }
        // },
        // OLD
        // getView(){            
        //     // this.updateTwoDaysBefore()
        //     // this.overlay = true;
        //     this.viewtable = []
        //     this.overlay = true;
        //     axios({
        //         method : 'POST',
        //         url : 'api/view-table',
        //         data : {
        //             dateFilter : this.filterDateSelection,
        //             hrd_accept : this.hrdAcceptSelect,
        //             express : this.expressSelect,
        //             dateFrom : this.dateFrom,
        //             dateTo : this.dateTo,
        //             loggedInUser : this.loggedInUser,
        //             search: this.search,
        //         }
        //     }).then( res => {
        //         this.viewtable = res.data.result;
        //         this.totalRecord = res.data.totalRecords;
        //         this.viewtable.forEach((element, index) => {
        //             element.attachments.forEach((el, ii) => {
        //                 if(el.att_column_name == 'CAD依頼書結合ファイル'){
        //                     // Remove the element from its current index
        //                     let arr = element.attachments.splice(ii, 1)[0];
        //                     // Insert the element at the target index
        //                     element.attachments.splice(0, 0, arr)
        //                 }

        //                 if(el.att_column_name == 'CAD依頼書'){
        //                     // Remove the element from its current index
        //                     let arr = element.attachments.splice(ii, 1)[0];
        //                     // Insert the element at the target index
        //                     element.attachments.splice(1, 0, arr)
        //                 }

        //             })
        //             // RADIO 8
        //             if(element.revision_type == '8' && /[a-zA-Z]/.test(element.revision_number)){
        //                 element.cad = 1;
        //             } else {
        //                 element.cad = 0;
        //             }
        //         });
        //         // console.log(res.data,'res')

        //         this.viewtable = this.viewtable.filter( r=> r.created_at = r.created_at ? moment(r.created_at).format("YYYY-MM-DD HH:mm:ss") : '')
        //         this.overlay = false;
        //         // console.log(this.viewtable,'viewtable')
        //         // if (this.viewtable.length === this.totalRecord) {
        //         //     this.overlay = false;
        //         // }
        //     });
        // },

        // ----------- N E W -----------
        getView(){   
            this.ConvertPlanNumber(this.search)
            this.overlay = true
            axios({
                method : 'POST',
                url : `api/view-table?page=${this.currentPage}`,
                data : {
                    dateFilter : this.filterDateSelection,
                    hrd_accept : this.hrdAcceptSelect,
                    express : this.expressSelect,
                    dateFrom : this.dateFrom,
                    dateTo : this.dateTo,
                    loggedInUser : this.loggedInUser,
                    search: this.constructionCode,
                    createdSort: this.createdSort,
                    hrdAcceptSort: this.hrdAcceptSort
                }
            }).then( res => {
                // console.log(res.data)
                // this.viewtable = res.data.data.sort((a,b) => b.express - a.express)
                this.viewtable = res.data.data
                this.metaData = res.data
                this.totalRecord = res.data.total
                this.totalFrom = res.data.from
                this.totalTo = res.data.to
                this.next_page_url = this.metaData.next_page_url
                this.lastPage = this.metaData.last_page
                this.viewtable.forEach((element, index) => {
                    element.attachments.forEach((el, ii) => {
                        if(el.att_column_name == 'CAD依頼書結合ファイル'){
                            // Remove the element from its current index
                            let arr = element.attachments.splice(ii, 1)[0];
                            // Insert the element at the target index
                            element.attachments.splice(0, 0, arr)
                        }

                        if(el.att_column_name == 'CAD依頼書'){
                            // Remove the element from its current index
                            let arr = element.attachments.splice(ii, 1)[0];
                            // Insert the element at the target index
                            element.attachments.splice(1, 0, arr)
                        }

                    })
                    // RADIO 8
                    if(element.revision_type == '8' && /[a-zA-Z]/.test(element.revision_number)){
                        element.cad = 1
                    } else {
                        element.cad = 0
                    }
                });
                this.viewtable = this.viewtable.filter( r=> r.created_at = r.created_at ? moment(r.created_at).format("YYYY-MM-DD HH:mm:ss") : '')
                this.overlay = false
            })
        },

        // ----------- O L D -----------
        // getAllData(){
        //     if(this.getTabName == 'HRD VIEW TABLE' || this.getTabName == 'PLANNER VIEW TABLE') {
        //         if(this.search.length == 12 || (this.search.length >= 16 && this.search.length <= 19)){
        //             // this.overlay = true;
        //             this.viewtable = []
        //             this.totalRecord = 0
        //             this.currentPage = 1
        //             this.filterDateSelection= "Show All";
        //             this.expressSelect = "All";
        //             this.hrdAcceptSelect= "All";
        //             // this.searchPlan();
        //             this.getView();
        //             // console.log('sampu ten')
        //         } 
        //         // if(this.search.length >= 12){
        //         //     this.filterDateSelection= "Show All";
        //         //     this.expressSelect = "All";
        //         //     this.hrdAcceptSelect= "All";
        //         //     this.searchPlan();
        //         //     // console.log('sampu ten')
        //         // } 
        //         else if (this.search == '') {
        //             // this.overlay = true;
        //             this.viewtable = []
        //             this.totalRecord = 0
        //             this.currentPage = 1
        //             this.filterDateSelection = "Filter By Date";
        //             this.expressSelect = "All";
        //             this.hrdAcceptSelect = "Not Yet Accepted";
        //             this.getView();
        //             // console.log('wala')
        //         }
        //     } else if(this.getTabName == 'XML BUNDLE SCHEDULE TABLE') {
        //         if(this.search.length == 12 || this.search.length >= 16 && this.search.length <= 19) {
        //             // this.searchXmlBundle();
        //             // this.overlay = true;
        //             // this.XmlData = []
        //             this.getXmlData();
        //             // this.xmlPage = 1;
        //         } else if(this.search == '') {
        //             // this.overlay = true;
        //             // this.XmlData = []
        //             this.getXmlData();
        //             // this.xmlPage = 1;
        //         }
        //     }
            
        //     // console.log(this.viewtable,'res')
        // },
        
        // ----------- N E W -----------
        getAllData(){
            this.currentPage = 1
            this.totalRecord = 0
            this.totalFrom = 0
            this.totalTo = 0
            if (this.defaultTab == 0 || this.defaultTab == 1) {
                this.viewtable = []
                this.getView()
            } else if (this.defaultTab == 2) {
                this.getXmlData()
            } else if (this.defaultTab == 3) {
                this.getForLoopSched()
            } else if (this.defaultTab == 4) {
                this.filterDateSelection = 'Filter By Date'
                this.overlay = true;
                axios({
                    method: 'POST',
                    url: 'api/getNotSentToBoss',
                    data : {
                        dateFrom : this.dateFrom,
                        dateTo : this.dateTo,
                    }
                }).then(({data}) => {
                    this.notUploaded = data
                })
                this.overlay = false
            }
        },

        searchAll() {
            this.currentPage = 1
            this.totalRecord = 0
            this.totalFrom = 0
            this.totalTo = 0
            if(this.search.length == 12 || (this.search.length >= 16 && this.search.length <= 19)){
                this.viewtable = []
                this.hrdAcceptSelect= "All"
                this.expressSelect = "All"
                this.filterDateSelection= "Show All"
                this.getView()
            } else if (this.search == '') {
                this.viewtable = []
                this.hrdAcceptSelect= "Not Yet Accepted"
                this.expressSelect = "All"
                this.filterDateSelection= "Filter By Date"
                this.getView()
            }
        },

        formatInput() {
            let cleanedInput = this.search.replace(/[^a-zA-Z0-9-]/g, '')

            if (cleanedInput.length > 6) {
                cleanedInput = cleanedInput.slice(0, 7) + '-' + cleanedInput.slice(7)
            }
            
            if (cleanedInput.length > 13) {
                cleanedInput = cleanedInput.slice(0, 13) + '-' + cleanedInput.slice(13)
            }

            cleanedInput = cleanedInput.replace(/-{2,}/g, '-')

            this.search = cleanedInput.toUpperCase()
        },

        loadPage(page) {
            this.currentPage = page;
            if (this.defaultTab == 0 || this.defaultTab == 1) {
                this.getView()
            } else if (this.defaultTab == 2) {
                this.getXmlData()
            }
        },

        loadPreviousPage() {
            if (this.metaData.prev_page_url) {
                this.currentPage--
                if (this.defaultTab == 0 || this.defaultTab == 1) {
                    this.getView()
                } else if (this.defaultTab == 2) {
                    this.getXmlData()
                }
            }
        },

        loadNextPage() {
            if (this.metaData.next_page_url) {
                this.currentPage++
                if (this.defaultTab == 0 || this.defaultTab == 1) {
                    this.getView()
                } else if (this.defaultTab == 2) {
                    this.getXmlData()
                }
            }
        },

        checkLoggedInUser(){
            if(!this.loggedInUser.is_admin){
                this.$store.state.columnRestriction = false;
            }
            // console.log(this.columnRestriction)
        },

        // handleContextMenu(event) {
        //     event.preventDefault();
        // },
        // handleKeyDown(event) {
        //     if ((event.key === 'F12') || ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I')) {
        //         event.preventDefault();
        //     }
        //     if (event.button === 2) {
        //         event.preventDefault();
        //     }
        // }
    }, 

    async mounted(){
        // window.addEventListener('keydown', this.handleKeyDown);
        // this.overlay = true;

        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        this.getSytemMaintenanceDatetime();
        
        if(this.loggedInUser.japan_admin == 1 || this.loggedInUser.is_rulebook_user == 1 || 
            this.loggedInUser.is_gc_user || this.loggedInUser.is_ichijo_user || this.loggedInUser.is_rulebook_user  || this.loggedInUser.is_special_account){
            this.hrdAcceptSelect = 'All'
        }

        if(this.loggedInUser.is_admin || this.loggedInUser.is_hrd_viewer || this.loggedInUser.is_hrd_requestor || this.loggedInUser.plan_control) {
            this.getTabName = 'HRD VIEW TABLE';
            this.hrdAcceptSelect = 'Not Yet Accepted'
        }
        if(this.loggedInUser.is_gc_user || this.loggedInUser.is_ichijo_user || this.loggedInUser.is_rulebook_user || this.loggedInUser.is_admin || this.loggedInUser.is_special_account || this.loggedInUser.japan_admin || this.loggedInUser.plan_control){
            this.getTabName = 'PLANNER VIEW TABLE';
        }
        await this.updateTwoDaysBefore();
        // await this.getXmlData()
        // await this.getView();
        // await this.getUsers();
        // await this.getAllData();

        if(this.$route.path == '/viewtable'){
            // this.filterByTab();
            await this.getAllData();
        }
        await this.checkLoggedInUser();
        // await this._getRemarks();
        // this.overlay = false;
        await this._getPlanner()
    },

    beforeDestroy() {
        // this.$refs.myTable.$el.removeEventListener('scroll', this.handleScroll);
      // Remove the keydown event listener when the component is destroyed
        // window.removeEventListener('keydown', this.handleKeyDown);
    },


    watch:{
        // StoreDialog(val){
        //     if(!val) this.$refs.Store.reset();
        // },
        overlay(val){
            // console.log(val, "overlay")
        },
    }

}
</script>

<style scoped>

    .th-sticky{
        position: sticky; 
        left: 0; 
        z-index: 1 !important;
    }

    .sticky-code{
        position : sticky;
        left : 0;
        top: 0;
        z-index: 5 !important;
    }

    .sticky-revision{
        position : sticky;
        left : 200px;
        top: 0;
        z-index: 5 !important;
    }

    .sticky-attach{
        position : sticky;
        left : 282px;
        top: 0;
        z-index: 5 !important;
    }

    .sticky-created{
        position : sticky;
        left : 389px;  
        top: 0; 
        z-index: 5 !important;
    }

    .sticky-view-code{
        position: sticky;
        left: 0;
        background-color: #fafafa !important;
        color:black !important;
        z-index: 4 !important;
    }

    .sticky-view-revision{
        position: sticky;
        left: 200px;
        background-color: #fafafa !important;
        color:black !important;
        z-index: 4 !important;
    }

    .sticky-view-attach{
        position: sticky;
        left : 282px;
        background-color: #fafafa !important;
        color:black !important;
        z-index: 4 !important;
    }

    .sticky-view-created{
        position: sticky;
        left : 389px;
        background-color: #fafafa !important;
        color:black !important;
        z-index: 4 !important;
    }

    .focus:focus::before {
        opacity: 0 !important;
    }

    .v-btn:focus::before {
        opacity: 0 !important;
    }

    .active-page {
        background-color: #333;
        color: #fff;
    }

    .newTable{
        text-align: center !important;
        border: 1px solid white !important;
    }

    .newTableTD{
        text-align: center !important;
        border: 1px solid rgb(200, 200, 200) !important;
    }
    /* .v-data-table.colorView th {
        border: 1px solid black;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
        border-bottom: 1px solid black !important;
    }

     .v-data-table.colorView td {
        border-bottom: 1px solid white !important;
    }

     .v-data-table.requestView td {
        border-top: 1px solid black ;
        border-right: 1px solid black !important;
        border-left: 1px solid black !important;
    }
     */
    .left-sticky {
        /* width: 5px !important; */
        position: sticky;
        left: 0;
        z-index: 1;
        border-top: 1px solid black !important;
        border-left: 1px solid black !important;
        border-right: 1px solid black !important;
    }
.disabled-button-style {
  /* Apply your desired styles for the disabled button */
  opacity: 0.5; /* Example: reduce opacity for disabled button */
  cursor: not-allowed; /* Example: change cursor to 'not-allowed' */

}
.v-btn--fab{
    bottom: 12px;
}

/*
.v-btn--fab.float-add,.v-btn--fab.float-delete{
    right:100px;
}
*/

/* .v-btn--fab.float-edit,.v-btn--fab.float-close,.v-btn--fab.settings{
    right:24px;
} */

.v-btn--fab.float-add{
    /* right:24px; */
    right:80px;
}


/* .v-btn--floating {
    position: relative;
    float:right !important;
  } */

.active-tab {
    background-color:#34495e;
    color:white;
}
.centered-div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
